export const SOFTWARE_INITIALIZED = "SOFTWARE_INITIALIZED";
export const SOFTWARE_NOT_INITIALIZED = "SOFTWARE_NOT_INITIALIZED";
export const SOFTWARE_START_INITIALIZATION = "SOFTWARE_START_INITIALIZATION";
export const INCREASE_LOADING = "INCREASE_LOADING";
export const PROCESS_LOADING = "PROCESS_LOADING";
export const RCC_INITIALIZED = "RCC_INITIALIZED";
export const DRIVERS_INITIALIZED = "DRIVERS_INITIALIZED";
export const MACHINE_INITIALIZED = "MACHINE_INITIALIZED";
export const PRINTER_INITIALIZED = "PRINTER_INITIALIZED";
export const SPECTRO_INITIALIZED = "SPECTRO_INITIALIZED";

// unknown
export const UNKNOWN_ACTION = "UNKNOWN_ACTION";
export const UNKNOWN_RCC_ACTION = "UNKNOWN_RCC_ACTION";
export const UNKNOWN_HELPER_ACTION = "UNKNOWN_HELPER_ACTION";
export const FAILED_ACTION = "FAILED_ACTION";

// server actions
export const CONNECT_DEFAULT_SERVER = "CONNECT_DEFAULT_SERVER";
export const DROP_SERVERS = "DROP_SERVERS";
export const SERVER_CONNECT = "SERVER_CONNECT";
export const SERVER_RECONNECT = "SERVER_RECONNECT";
export const SERVER_DISCONNECT = "SERVER_DISCONNECT";
export const SERVER_REQUEST = "SERVER_REQUEST";
export const SET_ACTIVE_SERVER = "SET_ACTIVE_SERVER";
export const SET_ACTIVE_SERVER_BY_URL = "SET_ACTIVE_SERVER_BY_URL";
export const SAVE_ACTIVE_SERVER_URL = "SAVE_ACTIVE_SERVER_URL";
export const SAVE_MULTICAST_SERVER_LIST = "SAVE_MULTICAST_SERVER_LIST";
export const SERVER_IS_LICENSED = "SERVER_IS_LICENSED";
export const SERVER_IS_LICENSED_COMPACT = "SERVER_IS_LICENSED_COMPACT";
export const SERVER_NOT_LICENSED = "SERVER_NOT_LICENSED";
export const SERVER_COMPATIBLE = "SERVER_COMPATIBLE";
export const SERVER_NOT_COMPATIBLE = "SERVER_NOT_COMPATIBLE";
export const DATABASE_COMPATIBLE = "DATABASE_COMPATIBLE";
export const DATABASE_NOT_COMPATIBLE = "DATABASE_NOT_COMPATIBLE";
export const DATABASE_AVAILABLE = "DATABASE_AVAILABLE";
export const DATABASE_NOT_AVAILABLE = "DATABASE_NOT_AVAILABLE";
export const RESET_SERVER_CONNECTION = "RESET_SERVER_CONNECTION";
export const CLOSE_SERVER_CONNECTION = "CLOSE_SERVER_CONNECTION";
export const SAVE_SERVER_MANAGEMENT_LIST = "SAVE_SERVER_MANAGEMENT_LIST";
export const SAVE_COMPATIBLE_SERVER_LIST = "SAVE_COMPATIBLE_SERVER_LIST";
export const SAVE_PROCESSED_COMPATIBLE_SERVER_LIST = "SAVE_PROCESSED_COMPATIBLE_SERVER_LIST";
export const SAVE_SERVER_INFO = "SAVE_SERVER_INFO";
export const SAVE_SERVER_CONFIGURATION = "SAVE_SERVER_CONFIGURATION";
export const SAVE_COMPUTER_ID = "SAVE_COMPUTER_ID";
export const SAVE_REGISTRATION_DATA = "SAVE_REGISTRATION_DATA";
export const SAVE_SERVER_PLUGINS = "SAVE_SERVER_PLUGINS";
export const SAVE_DISABLED_PRODUCTS = "SAVE_DISABLED_PRODUCTS";
export const SAVE_DISABLED_FANDECKS = "SAVE_DISABLED_FANDECKS";
export const SET_CLIENT_IDENTIFIER = "SET_CLIENT_IDENTIFIER";
export const SET_ORDER_MORE_INFO = "SET_ORDER_MORE_INFO";
export const PREPARE_FILE_BACKUP_LOCAL_DB = "PREPARE_FILE_BACKUP_LOCAL_DB";
export const PREPARE_FILE_LOCAL = "PREPARE_FILE_LOCAL";
export const PREPARE_FILE_PRICING_DATA = "PREPARE_FILE_PRICING_DATA";
export const PREPARE_FILE_STATS_DATA = "PREPARE_FILE_STATS_DATA";
export const SERVER_PREPARE_FILE_SUCCESS = "SERVER_PREPARE_FILE_SUCCESS";
export const SERVER_PREPARE_FILE_ERROR = "SERVER_PREPARE_FILE_ERROR";
export const SERVER_SAVE_FILE_INFORMATION = "SERVER_SAVE_FILE_INFORMATION";
export const SERVER_UPDATE_FILE = "SERVER_UPDATE_FILE";
export const SERVER_UPDATE_FILE_INFORMATION = "SERVER_UPDATE_FILE_INFORMATION";
export const SERVER_DELETE_DOWNLOADED_FILE = "SERVER_DELETE_DOWNLOADED_FILE";
export const RCC_PREPARE_FILE_SUCCESS = "RCC_PREPARE_FILE_SUCCESS";
export const RCC_PREPARE_FILE_ERROR = "RCC_PREPARE_FILE_ERROR";
export const RCC_SAVE_FILE_INFORMATION = "RCC_SAVE_FILE_INFORMATION";
export const RCC_UPDATE_FILE_INFORMATION = "RCC_UPDATE_FILE_INFORMATION";
export const RCC_DELETE_DOWNLOADED_FILE = "RCC_DELETE_DOWNLOADED_FILE";
export const PREPARE_FILE_CHANNEL_ALL_STATS_DATA = "PREPARE_FILE_CHANNEL_ALL_STATS_DATA";
export const PREPARE_FILE_CHANNEL_DISPENSE_STATS_DATA = "PREPARE_FILE_CHANNEL_DISPENSE_STATS_DATA";
export const PREPARE_FILE_CHANNEL_PURGE_STATS_DATA = "PREPARE_FILE_CHANNEL_PURGE_STATS_DATA";
export const DELETE_ALL_IMPORTED_RECORDS = "DELETE_ALL_IMPORTED_RECORDS";
export const SAVE_EXCEL_FILE_ANALYSIS = "SAVE_EXCEL_FILE_ANALYSIS";
export const SAVE_EXCEL_FILE_ITEM = "SAVE_EXCEL_FILE_ITEM";
export const SAVE_EXCEL_FILE_STEP = "SAVE_EXCEL_FILE_STEP";
export const SAVE_EXCEL_FILE_RESULT = "SAVE_EXCEL_FILE_RESULT";

// license
export const LICENSE_SET_IDENTIFICATION = "LICENSE_SET_IDENTIFICATION";
export const LICENSE_DELETE_IDENTIFICATION = "LICENSE_DELETE_IDENTIFICATION";
export const LICENSE_SAVE_PRODUCT_LIST = "LICENSE_SAVE_PRODUCT_LIST";
export const LICENSE_SAVE_PRODUCT_LIST_ORDER = "LICENSE_SAVE_PRODUCT_LIST_ORDER";
export const LICENSE_SET_PRODUCT = "LICENSE_SET_PRODUCT";
export const LICENSE_SET_DATA = "LICENSE_SET_DATA";
export const LICENSE_SAVE_REQUEST = "LICENSE_SAVE_REQUEST";
export const LICENSE_SAVE_ONLINE_ACTIVATION = "LICENSE_SAVE_ONLINE_ACTIVATION";
export const LICENSE_SAVE_ONLINE_ACTIVATION_FOR_WIZARD = "LICENSE_SAVE_ONLINE_ACTIVATION_FOR_WIZARD";
export const LICENSE_GET_ONLINE_COUNTS = "LICENSE_GET_ONLINE_COUNTS";
export const LICENSE_SAVE_ONLINE_COUNTS = "LICENSE_SAVE_ONLINE_COUNTS";
export const LICENSE_SET_PROCESS_STEP = "LICENSE_SET_PROCESS_STEP";
export const LICENSE_SAVE_INFO = "LICENSE_SAVE_INFO";
export const LICENSE_SAVE_ERROR = "LICENSE_SAVE_ERROR";

// actions for websocket communication with server
export const WEBSOCKET_CONNECTING = "WEBSOCKET_CONNECTING";
export const WEBSOCKET_OPENED = "WEBSOCKET_OPENED";
export const WEBSOCKET_CLOSED = "WEBSOCKET_CLOSED";
export const WEBSOCKET_REQUEST = "WEBSOCKET_REQUEST";
export const WEBSOCKET_RESPONSE = "WEBSOCKET_RESPONSE";
export const SAVE_WEBSOCKET_REQUEST = "SAVE_WEBSOCKET_REQUEST";
export const REMOVE_WEBSOCKET_REQUEST = "REMOVE_WEBSOCKET_REQUEST";
export const SKIP_WEBSOCKET_REQUEST = "SKIP_WEBSOCKET_REQUEST";
export const WEBSOCKET_PING = "WEBSOCKET_PING";

// module actions
export const SAVE_MODULE = "SAVE_MODULE";
export const CHANGE_MODULE = "CHANGE_MODULE";
export const CHANGE_SOFTWARE_TYPE = "CHANGE_SOFTWARE_TYPE";
export const PLUGINS_SET_WINTER = "PLUGINS_SET_WINTER";
export const PLUGINS_RELOAD_WINTER_TIME = "PLUGINS_RELOAD_WINTER_TIME";

// RCC actions
export const RCC_CONNECT = "RCC_CONNECT";
export const RCC_DISCONNECT = "RCC_DISCONNECT";
export const RCC_REQUEST = "RCC_REQUEST";
export const RCC_SPECTRO_REQUEST = "RCC_SPECTRO_REQUEST";
export const RCC_SIMPLE_REQUEST = "RCC_SIMPLE_REQUEST";
export const RCC_SET_URL = "RCC_SET_URL";
export const RCC_SAVE_URL = "RCC_SAVE_URL";

// actions for websocket communication with control center
export const RCC_WEBSOCKET_CONNECTING = "RCC_WEBSOCKET_CONNECTING";
export const RCC_WEBSOCKET_OPENED = "RCC_WEBSOCKET_OPENED";
export const RCC_WEBSOCKET_CLOSED = "RCC_WEBSOCKET_CLOSED";
export const RCC_WEBSOCKET_ERROR = "RCC_WEBSOCKET_ERROR";
export const RCC_WEBSOCKET_REQUEST = "RCC_WEBSOCKET_REQUEST";
export const RCC_WEBSOCKET_RESPONSE = "RCC_WEBSOCKET_RESPONSE";
export const SAVE_RCC_WEBSOCKET_REQUEST = "SAVE_RCC_WEBSOCKET_REQUEST";
export const REMOVE_RCC_WEBSOCKET_REQUEST = "REMOVE_RCC_WEBSOCKET_REQUEST";
export const SAVE_RCC_ASYNC_RESPONSE = "SAVE_RCC_ASYNC_RESPONSE";
export const REMOVE_RCC_ASYNC_RESPONSE = "REMOVE_RCC_ASYNC_RESPONSE";

// Helper Server actions
export const HELPER_CONNECT = "HELPER_CONNECT";
export const HELPER_DISCONNECT = "HELPER_DISCONNECT";
export const HELPER_REQUEST = "HELPER_REQUEST";
export const SAVE_HELPER_DIALOG = "SAVE_HELPER_DIALOG";
export const SAVE_HELPER_UPDATE_CONFIGURATION = "SAVE_HELPER_UPDATE_CONFIGURATION";
export const HELPER_SAVE_SHOW_DIALOG = "HELPER_SAVE_SHOW_DIALOG";
export const SAVE_HELPER_IS_ONLINE = "SAVE_HELPER_IS_ONLINE";
export const SAVE_HELPER_LOG_FILES = "SAVE_HELPER_LOG_FILES";
export const SEND_HELPER_BUG_REPORT = "SEND_HELPER_BUG_REPORT";
export const HELPER_OPEN_DIALOG = "HELPER_OPEN_DIALOG";
export const HELPER_SAVE_DOWNLOADED_PROGRESS = "HELPER_SAVE_DOWNLOADED_PROGRESS";
export const HELPER_PREPARE_LOG_FILES = "HELPER_PREPARE_LOG_FILES";
export const HELPER_SAVE_DOWNLOADED_LOG_ARCHIVE_LENGTH = "HELPER_SAVE_DOWNLOADED_LOG_ARCHIVE_LENGTH";
export const HELPER_SAVE_TOTAL_LOG_ARCHIVE_LENGTH = "HELPER_SAVE_TOTAL_LOG_ARCHIVE_LENGTH";
export const HELPER_SAVE_LOG_ARCHIVE_PATH = "HELPER_SAVE_LOG_ARCHIVE_PATH";
export const HELPER_RESET_LOG_ARCHIVE_PARAMETERS = "HELPER_RESET_LOG_ARCHIVE_PARAMETERS";
export const HELPER_PREPARE_FILE_SUCCESS = "HELPER_PREPARE_FILE_SUCCESS";
export const HELPER_PREPARE_FILE_ERROR = "HELPER_PREPARE_FILE_ERROR";

// actions for websocket communication with Helper Server
export const HELPER_WEBSOCKET_CONNECTING = "HELPER_WEBSOCKET_CONNECTING";
export const HELPER_WEBSOCKET_OPENED = "HELPER_WEBSOCKET_OPENED";
export const HELPER_WEBSOCKET_CLOSED = "HELPER_WEBSOCKET_CLOSED";
export const HELPER_WEBSOCKET_REQUEST = "HELPER_WEBSOCKET_REQUEST";
export const HELPER_WEBSOCKET_RESPONSE = "HELPER_WEBSOCKET_RESPONSE";
export const SAVE_HELPER_WEBSOCKET_REQUEST = "SAVE_HELPER_WEBSOCKET_REQUEST";
export const REMOVE_HELPER_WEBSOCKET_REQUEST = "REMOVE_HELPER_WEBSOCKET_REQUEST";
export const SAVE_HELPER_ASYNC_RESPONSE = "SAVE_HELPER_ASYNC_RESPONSE";
export const REMOVE_HELPER_ASYNC_RESPONSE = "REMOVE_HELPER_ASYNC_RESPONSE";

// global
export const CUSTOM_TAB_SAVE_PACKAGE_LIST = "CUSTOM_TAB_SAVE_PACKAGE_LIST";
export const DELETE_ITEM_CONFIRMATION = "DELETE_ITEM_CONFIRMATION";
export const GLOBAL_STORE_INIT = "GLOBAL_STORE_INIT";
export const GLOBAL_STORE_RELOAD = "GLOBAL_STORE_RELOAD";
export const LOAD_SELECTED_USER_GROUP_LIST = "LOAD_SELECTED_USER_GROUP_LIST";
export const MACHINE_VALIDATE_CANISTER_BARCODE = "MACHINE_VALIDATE_CANISTER_BARCODE";
export const RELOAD_FORMULA_LIST = "RELOAD_FORMULA_LIST";
export const RESET_FORMULA_LIST = "RESET_FORMULA_LIST";
export const SAVE_ACTIVE_USER = "SAVE_ACTIVE_USER";
export const SAVE_ALL_COLORANT_LIST = "SAVE_ALL_COLORANT_LIST";
export const SAVE_BATCHES_BY_COLORANT = "SAVE_BATCHES_BY_COLORANT";
export const SAVE_COLORANT_LIST = "SAVE_COLORANT_LIST";
export const SAVE_CUSTOM_FANDECK_LIST = "SAVE_CUSTOM_FANDECK_LIST";
export const SAVE_FANDECK_LIST = "SAVE_FANDECK_LIST";
export const SAVE_FAVORITE_FORMULA_LIST = "SAVE_FAVORITE_FORMULA_LIST";
export const FILE_TRANSFER_FINISHED = "FILE_TRANSFER_FINISHED";
export const FILE_TRANSFER_PROCEEDED = "FILE_TRANSFER_PROCEEDED";
export const FILE_TRANSFER_STARTED = "FILE_TRANSFER_STARTED";
export const FILE_TRANSFER_FILE_AVAILABLE = "FILE_TRANSFER_FILE_AVAILABLE";
export const SAVE_FILE_TRANSFER_IN_FORMATS = "SAVE_FILE_TRANSFER_IN_FORMATS";
export const SAVE_FILE_TRANSFER_OUT_FORMATS = "SAVE_FILE_TRANSFER_OUT_FORMATS";
export const SAVE_FILE_TRANSFER_PROTOCOL_LIST = "SAVE_FILE_TRANSFER_PROTOCOL_LIST";
export const SAVE_FORMULA_LIST = "SAVE_FORMULA_LIST";
export const SAVE_LAST_DISPENSED_FORMULA_LIST = "SAVE_LAST_DISPENSED_FORMULA_LIST";
export const SAVE_PRODUCT_LIST = "SAVE_PRODUCT_LIST";
export const SAVE_PRODUCT_SIMPLE_LIST = "SAVE_PRODUCT_SIMPLE_LIST";
export const SAVE_SELECTED_USER_GROUPS = "SAVE_SELECTED_USER_GROUPS";
export const SAVE_TINTOMETRIC_SYSTEM = "SAVE_TINTOMETRIC_SYSTEM";
export const SAVE_TINTOMETRIC_SYSTEM_LIST = "SAVE_TINTOMETRIC_SYSTEM_LIST";
export const SAVE_UNIT_LIST = "SAVE_UNIT_LIST";
export const SAVE_USER_GROUPS_LIST = "SAVE_USER_GROUPS_LIST";
export const SAVE_USER_LIST = "SAVE_USER_LIST";

// login
export const LOG_IN = "LOG_IN";
export const LOG_IN_SUCCESS = "LOG_IN_SUCCESS";
export const LOG_IN_FAILURE = "LOG_IN_FAILURE";
export const LOG_IN_SET_LOGIN = "LOG_IN_SET_LOGIN";
export const LOG_IN_SET_PASSWORD = "LOG_IN_SET_PASSWORD";
export const LOG_OUT_SUCCESS = "LOG_OUT_SUCCESS";
export const CHANGE_USER_SUCCESS = "CHANGE_USER_SUCCESS";
export const LOG_OUT_AND_REACTIVATE = "LOG_OUT_AND_REACTIVATE";
export const USER_AUTHENTICATION = "USER_AUTHENTICATION";

// database
export const SAVE_DATABASE_LIST = "SAVE_DATABASE_LIST";
export const SAVE_DATABASES_READY_FOR_PARTIAL_UPDATES = "SAVE_DATABASES_READY_FOR_PARTIAL_UPDATES";
export const SAVE_ALL_DATABASE_LIST = "SAVE_ALL_DATABASE_LIST";
export const SAVE_ACTIVE_DATABASE = "SAVE_ACTIVE_DATABASE";
export const DATABASE_CHANGE = "DATABASE_CHANGE";
export const DATABASE_CHANGE_GAMMA = "DATABASE_CHANGE_GAMMA";
export const START_DATABASE_UPDATE = "START_DATABASE_UPDATE";
export const DATABASE_UPDATE_IN_PROGRESS = "DATABASE_UPDATE_IN_PROGRESS";
export const DATABASE_UPDATE_FINISHED = "DATABASE_UPDATE_FINISHED";
export const INCREASE_NUMBER_OF_DATABASE_UPDATES = "INCREASE_NUMBER_OF_DATABASE_UPDATES";

//navigation
export const INIT_TAB_LIST = "INIT_TAB_LIST";
export const INIT_FORMULA_TAB_LIST = "INIT_FORMULA_TAB_LIST";
export const ADD_NEW_TAB = "ADD_NEW_TAB";
export const PREPARE_NEW_TAB = "PREPARE_NEW_TAB";
export const SAVE_NEW_TAB = "SAVE_NEW_TAB";
export const SAVE_TAB_OR_OPEN_EXISTING_TAB = "SAVE_TAB_OR_OPEN_EXISTING_TAB";
export const ADD_NEW_MAIN_TAB = "ADD_NEW_MAIN_TAB";
export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const SET_ACTIVE_TAB_SCENE = "SET_ACTIVE_TAB_SCENE";
export const SET_ACTIVE_TAB_AND_SCENE = "SET_ACTIVE_TAB_AND_SCENE";
export const SET_AUTOMATIC_MAIN_TAB_SCENE = "SET_AUTOMATIC_MAIN_TAB_SCENE";
export const UPDATE_TAB_NAME = "UPDATE_TAB_NAME";
export const UPDATE_TAB_COLOR = "UPDATE_TAB_COLOR";
export const UPDATE_CUSTOM_TAB_NAME = "UPDATE_CUSTOM_TAB_NAME";
export const CLOSE_ACTIVE_TAB = "CLOSE_ACTIVE_TAB";
export const CLOSE_ALL_TABS = "CLOSE_ALL_TABS";
export const CLOSE_ALL_TABS_EXCEPT_ACTIVE = "CLOSE_ALL_TABS_EXCEPT_ACTIVE";
export const CHANGE_TAB_ORDER = "CHANGE_TAB_ORDER";
export const MENU_SHOW = "MENU_SHOW";
export const MENU_HIDE = "MENU_HIDE";
export const NAVIGATION_SELECT_FORMULA = "NAVIGATION_SELECT_FORMULA";
export const NAVIGATION_AFTER_SAVE_FORMULA_DATA = "NAVIGATION_AFTER_SAVE_FORMULA_DATA";
export const NAVIGATION_SAVE_FORMULA = "NAVIGATION_SAVE_FORMULA";
export const NAVIGATION_SAVE_QUICK_TINT_FORMULA = "NAVIGATION_SAVE_QUICK_TINT_FORMULA";
export const NAVIGATION_OPEN_MODAL = "NAVIGATION_OPEN_MODAL";
export const NAVIGATION_CLOSE_MODAL = "NAVIGATION_CLOSE_MODAL";
export const NAVIGATION_CLOSE_ACTIVE_MODAL = "NAVIGATION_CLOSE_ACTIVE_MODAL";
export const NAVIGATION_OPEN_JUST_ONE_MODAL = "NAVIGATION_OPEN_JUST_ONE_MODAL";
export const NAVIGATION_CLOSE_ALL_MODALS = "NAVIGATION_CLOSE_ALL_MODALS";
export const NAVIGATION_OPEN_HELP_MODAL = "NAVIGATION_OPEN_HELP_MODAL";
export const NAVIGATION_SET_MODAL_PARAMS = "NAVIGATION_SET_MODAL_PARAMS";
export const NAVIGATION_SET_NOTIFICATION_PANEL = "NAVIGATION_SET_NOTIFICATION_PANEL";
export const MENU_ADD_NEW_OR_OPEN_MAIN_TAB = "MENU_ADD_NEW_OR_OPEN_MAIN_TAB";
export const MENU_ADD_NEW_OR_RESET_MAIN_TAB = "MENU_ADD_NEW_OR_RESET_MAIN_TAB";
export const MENU_ADD_NEW_OR_OPEN_COLOR_PALETTE_TAB = "MENU_ADD_NEW_OR_OPEN_COLOR_PALETTE_TAB";
export const MENU_ADD_NEW_OR_OPEN_COLOR_SEARCH_TAB = "MENU_ADD_NEW_OR_OPEN_COLOR_SEARCH_TAB";
export const MENU_ADD_NEW_OR_OPEN_CUSTOM_TAB = "MENU_ADD_NEW_OR_OPEN_CUSTOM_TAB";
export const MENU_ADD_NEW_FAVORITES_TAB = "MENU_ADD_NEW_FAVORITES_TAB";
export const MENU_ADD_NEW_CANISTERS_TAB = "MENU_ADD_NEW_CANISTERS_TAB";
export const MENU_ADD_NEW_SPECTRO_TAB = "MENU_ADD_NEW_SPECTRO_TAB";
export const MENU_ADD_NEW_STATISTICS_TAB = "MENU_ADD_NEW_STATISTICS_TAB";
export const MENU_ADD_NEW_CUSTOMERS_TAB = "MENU_ADD_NEW_CUSTOMERS_TAB";
export const MENU_ADD_NEW_MATCHING_TAB = "MENU_ADD_NEW_MATCHING_TAB";
export const MENU_ADD_NEW_MY_ORDERS_TAB = "MENU_ADD_NEW_MY_ORDERS_TAB";
export const MENU_ADD_NEW_TICKETING_TAB = "MENU_ADD_NEW_TICKETING_TAB";
export const MENU_ADD_NEW_TO_DISPENSE_TAB = "MENU_ADD_NEW_TO_DISPENSE_TAB";
export const MENU_ADD_NEW_BUG_REPORT_TAB = "MENU_ADD_NEW_BUG_REPORT_TAB";
export const MENU_ADD_NEW_ORDERS_HISTORY_TAB = "MENU_ADD_NEW_ORDERS_HISTORY_TAB";
export const MENU_SET_MENU_ITEM = "MENU_SET_MENU_ITEM";
export const MENU_SET_SUBMENU_ITEM = "MENU_SET_SUBMENU_ITEM";
export const MENU_ADD_NEW_GLOBAL_SEARCH_TAB = "MENU_ADD_NEW_GLOBAL_SEARCH_TAB";
export const MATCHING_TAB_FROM_COLOR_SEARCH = "MATCHING_TAB_FROM_COLOR_SEARCH";
export const MATCHING_TAB_FROM_PALETTE = "MATCHING_TAB_FROM_PALETTE";
export const MATCHING_TAB_FROM_STATS = "MATCHING_TAB_FROM_STATS";
export const SAVE_FLASH_MESSAGE = "SAVE_FLASH_MESSAGE";
export const DELETE_FLASH_MESSAGE = "DELETE_FLASH_MESSAGE";
export const DELETE_ALL_FLASH_MESSAGES = "DELETE_ALL_FLASH_MESSAGES";
export const NAVIGATION_OPEN_SCREENSAVER = "NAVIGATION_OPEN_SCREENSAVER";
export const NAVIGATION_CLOSE_SCREENSAVER = "NAVIGATION_CLOSE_SCREENSAVER";
export const NAVIGATION_CLOSE_REDLIKE_WINDOW = "NAVIGATION_CLOSE_REDLIKE_WINDOW";
export const PROCESS_KEYBOARD_EVENT = "PROCESS_KEYBOARD_EVENT";
export const NAVIGATION_SET_ACTIVE_TUTORIAL = "NAVIGATION_SET_ACTIVE_TUTORIAL";
export const NAVIGATION_DISABLE_TUTORIAL = "NAVIGATION_DISABLE_TUTORIAL";
export const NAVIGATION_FINISH_TUTORIAL = "NAVIGATION_FINISH_TUTORIAL";
export const MENU_TRANSLATE_KEYWORDS = "MENU_TRANSLATE_KEYWORDS";
export const OPEN_MESSAGE_DIALOG = "OPEN_MESSAGE_DIALOG";
export const CANCEL_MESSAGE_DIALOG = "CANCEL_MESSAGE_DIALOG";
export const CANCEL_ALL_MESSAGE_DIALOGS = "CANCEL_ALL_MESSAGE_DIALOGS";
export const TOGGLE_MESSAGE_DIALOG = "TOGGLE_MESSAGE_DIALOG";
export const OPEN_CUSTOMER_IN_NEW_TAB = "OPEN_CUSTOMER_IN_NEW_TAB";
export const OPEN_TO_DISPENSE_ORDER_IN_NEW_TAB = "OPEN_TO_DISPENSE_ORDER_IN_NEW_TAB";
export const STORE_OPENED_TAB_LIST = "STORE_OPENED_TAB_LIST";
export const SET_PARTIAL_UPDATES_PREPARING = "SET_PARTIAL_UPDATES_PREPARING";

export const OPEN_CUSTOMER_HISTORY_TAB = "OPEN_CUSTOMER_HISTORY_TAB";
export const OPEN_NEW_MAIN_TAB = "OPEN_NEW_MAIN_TAB";
export const CLONE_FORMULA_DATA = "CLONE_FORMULA_DATA";
export const CLONE_FORMULA_DATA_AND_RESET = "CLONE_FORMULA_DATA_AND_RESET";
export const SAVE_FORMULA_AS_CUSTOM = "SAVE_FORMULA_AS_CUSTOM";
export const SAVE_MATCHING_FORMULA_AS_CUSTOM = "SAVE_MATCHING_FORMULA_AS_CUSTOM";
export const SAVE_HISTORY_FORMULA_AS_CUSTOM = "SAVE_HISTORY_FORMULA_AS_CUSTOM";
export const CLONE_MAIN_TO_CUSTOM_TAB = "CLONE_MAIN_TO_CUSTOM_TAB";
export const CLONE_MATCHING_TO_CUSTOM_TAB = "CLONE_MATCHING_TO_CUSTOM_TAB";
export const CLONE_HISTORY_TO_CUSTOM_TAB = "CLONE_HISTORY_TO_CUSTOM_TAB";
export const SAVE_CUSTOM_TAB_DATA = "SAVE_CUSTOM_TAB_DATA";
export const SAVE_ACTIVE_HELP = "SAVE_ACTIVE_HELP";
export const SET_RENDER = "SET_RENDER";
export const WINDOW_RESIZED = "WINDOW_RESIZED";
export const IMAGE_STORE_UPDATE = "IMAGE_STORE_UPDATE";
export const OPEN_HOME_TAB = "OPEN_HOME_TAB";

// filtering
export const FILTERING_INIT = "FILTERING_INIT";
export const FILTERING_SAVE_PARAMS = "FILTERING_SAVE_PARAMS";
export const FILTERING_SAVE_CUSTOM_PARAMS = "FILTERING_SAVE_CUSTOM_PARAMS";
export const FILTERING_SAVE_DEFAULT_PRODUCT_LIST = "FILTERING_SAVE_DEFAULT_PRODUCT_LIST";
export const FILTERING_SAVE_DEFAULT_FANDECK_LIST = "FILTERING_SAVE_DEFAULT_FANDECK_LIST";
export const FILTERING_SAVE_LOCAL_FANDECK_LIST = "FILTERING_SAVE_LOCAL_FANDECK_LIST";
export const FILTERING_SAVE_DEFAULT_FORMULA_LIST = "FILTERING_SAVE_DEFAULT_FORMULA_LIST";
export const FILTERING_SAVE_LOCAL_FORMULA_LIST = "FILTERING_SAVE_LOCAL_FORMULA_LIST";
export const FILTERING_SAVE_DEFAULT_FORMULA_CODE_LIST = "FILTERING_SAVE_DEFAULT_FORMULA_CODE_LIST";
export const FILTERING_SAVE_LOCAL_FORMULA_CODE_LIST = "FILTERING_SAVE_LOCAL_FORMULA_CODE_LIST";
export const FILTERING_SAVE_DEFAULT_BASE_LIST = "FILTERING_SAVE_DEFAULT_BASE_LIST";
export const FILTERING_SAVE_DEFAULT_PACKAGE_LIST = "FILTERING_SAVE_DEFAULT_PACKAGE_LIST";
export const FILTERING_SAVE_DEFAULT_CUSTOMER_LIST = "FILTERING_SAVE_DEFAULT_CUSTOMER_LIST";

// statistics tab
export const STATISTICS_TAB_INIT = "STATISTICS_TAB_INIT";
export const STATISTICS_TAB_SAVE_FORMULA_LIST = "STATISTICS_TAB_SAVE_FORMULA_LIST";
export const STATISTICS_TAB_SAVE_FORMULA_LIST_WITH_OFFSET = "STATISTICS_TAB_SAVE_FORMULA_LIST_WITH_OFFSET";
export const LOAD_FORMULA_DATA_FROM_STATS = "LOAD_FORMULA_DATA_FROM_STATS";
export const LOAD_FORMULA_META_DATA_FROM_STATS = "LOAD_FORMULA_META_DATA_FROM_STATS";
export const SAVE_FORMULA_DATA_FROM_STATS = "SAVE_FORMULA_DATA_FROM_STATS";
export const UPDATE_FORMULA_DATA_FROM_STATS = "UPDATE_FORMULA_DATA_FROM_STATS";
export const STATISTICS_TAB_SAVE_SORTING = "STATISTICS_TAB_SAVE_SORTING";
export const SAVE_FORMULA_STATISTICS_ID = "SAVE_FORMULA_STATISTICS_ID";
export const STATISTICS_SAVE_FILTER = "STATISTICS_SAVE_FILTER";
export const STATISTICS_CHANGE_OFFSET = "STATISTICS_CHANGE_OFFSET";
export const STATISTICS_SET_SHOW_HIDDEN = "STATISTICS_SET_SHOW_HIDDEN";
export const STATISTICS_LIST_UPDATE = "STATISTICS_LIST_UPDATE";
export const STATISTICS_TAB_START_RETINT = "STATISTICS_TAB_START_RETINT";
export const ADD_COLOR_STATS_FROM_STATS_AND_DISPENSE = "ADD_COLOR_STATS_FROM_STATS_AND_DISPENSE";
export const STATISTICS_TAB_GET_FORMULA_LIST_WITH_OFFSET = "STATISTICS_TAB_GET_FORMULA_LIST_WITH_OFFSET";
export const STATISTICS_TAB_SET_NUMBER_OF_PACKAGES = "STATISTICS_TAB_SET_NUMBER_OF_PACKAGES";

// ticketing tab
export const TICKETING_TAB_INIT = "TICKETING_TAB_INIT";
export const SAVE_TICKETS = "SAVE_TICKETS";
export const TICKETS_INCREASE_NEW_NOTIFICATION_COUNT = "TICKETS_INCREASE_NEW_NOTIFICATION_COUNT";
export const TICKETING_SAVE_FANDECK_LIST = "TICKETING_SAVE_FANDECK_LIST";
export const TICKETING_SAVE_COLOR_LIST = "TICKETING_SAVE_COLOR_LIST";
export const TICKETING_SAVE_PRODUCT_LIST = "TICKETING_SAVE_PRODUCT_LIST";
export const TICKETING_SAVE_BASE_LIST = "TICKETING_SAVE_BASE_LIST";
export const TICKETING_SAVE_SERVICE_DEPARTMENTS = "TICKETING_SAVE_SERVICE_DEPARTMENTS";

// TMC
export const TMC_AVAILABLE = "TMC_AVAILABLE";

// my orders tab
export const MY_ORDERS_SAVE_DATA = "MY_ORDERS_SAVE_DATA";
export const MY_ORDERS_SAVE_DATA_WITH_OFFSET = "MY_ORDERS_SAVE_DATA_WITH_OFFSET";
export const MY_ORDERS_TAB_INIT = "MY_ORDERS_TAB_INIT";
export const MY_ORDERS_SAVE_DETAIL = "MY_ORDERS_SAVE_DETAIL";
export const MY_ORDERS_SAVE_SORTING = "MY_ORDERS_SAVE_SORTING";
export const MY_ORDERS_SAVE_FILTER = "MY_ORDERS_SAVE_FILTER";
export const MY_ORDERS_CHANGE_OFFSET = "MY_ORDERS_CHANGE_OFFSET";
export const MY_ORDERS_LIST_UPDATE = "MY_ORDERS_LIST_UPDATE";
export const MY_ORDERS_SAVE_PACKAGE_PREVIEW_IMAGE = "MY_ORDERS_SAVE_PACKAGE_PREVIEW_IMAGE";

// to dispense tab
export const TO_DISPENSE_TAB_INIT = "TO_DISPENSE_TAB_INIT";
export const TO_DISPENSE_SAVE_ORDERS = "TO_DISPENSE_SAVE_ORDERS";
export const TO_DISPENSE_SAVE_ORDERS_WITH_OFFSET = "TO_DISPENSE_SAVE_ORDERS_WITH_OFFSET";
export const TO_DISPENSE_PROCESS_NOTIFICATION_ORDERS = "TO_DISPENSE_PROCESS_NOTIFICATION_ORDERS";
export const TO_DISPENSE_SAVE_NOTIFICATION_ORDERS = "TO_DISPENSE_SAVE_NOTIFICATION_ORDERS";
export const TO_DISPENSE_SAVE_ORDER_DETAIL = "TO_DISPENSE_SAVE_ORDER_DETAIL";
export const TO_DISPENSE_SAVE_PLAIN_ORDER_DETAIL = "TO_DISPENSE_SAVE_PLAIN_ORDER_DETAIL";
export const SAVE_ORDER_STATUS = "SAVE_ORDER_STATUS";
export const TO_DISPENSE_CHANGE_NUMBER_OF_PACKAGES = "TO_DISPENSE_CHANGE_NUMBER_OF_PACKAGES";
export const TO_DISPENSE_PRINT_ORDER_WHILE_DISPENSING = "TO_DISPENSE_PRINT_ORDER_WHILE_DISPENSING";
export const TO_DISPENSE_SAVE_FORMULA_VALIDATION = "TO_DISPENSE_SAVE_FORMULA_VALIDATION";
export const TO_DISPENSE_START_FORMULA_DISPENSING = "TO_DISPENSE_START_FORMULA_DISPENSING";
export const TO_DISPENSE_SAVE_SORTING = "TO_DISPENSE_SAVE_SORTING";
export const TO_DISPENSE_RESET_NEW_ORDERS = "TO_DISPENSE_RESET_NEW_ORDERS";
export const TO_DISPENSE_SAVE_FILTER = "TO_DISPENSE_SAVE_FILTER";
export const TO_DISPENSE_CHANGE_OFFSET = "TO_DISPENSE_CHANGE_OFFSET";
export const TO_DISPENSE_SAVE_FILTER_TYPE = "TO_DISPENSE_SAVE_FILTER_TYPE";
export const TO_DISPENSE_SET_COLORANT_DISPENSING_LOGIC = "TO_DISPENSE_SET_COLORANT_DISPENSING_LOGIC";
export const TO_DISPENSE_SAVE_PACKAGE_PREVIEW_IMAGE = "TO_DISPENSE_SAVE_PACKAGE_PREVIEW_IMAGE";
export const TO_DISPENSE_LIST_UPDATE = "TO_DISPENSE_LIST_UPDATE";
export const TO_DISPENSE_RESET_ORDER = "TO_DISPENSE_RESET_ORDER";
export const TO_DISPENSE_SAVE_DISPENSED_ORDER_NOTE = "TO_DISPENSE_SAVE_DISPENSED_ORDER_NOTE";
export const TO_DISPENSE_START_DISPENSING = "TO_DISPENSE_START_DISPENSING";
export const ADD_COLOR_STATS_FROM_ORDER_AND_DISPENSE = "ADD_COLOR_STATS_FROM_ORDER_AND_DISPENSE";

// orders history
export const ORDERS_HISTORY_INIT = "ORDERS_HISTORY_INIT";
export const ORDERS_HISTORY_CHANGE_OFFSET = "ORDERS_HISTORY_CHANGE_OFFSET";
export const ORDERS_HISTORY_SAVE_FILTER = "ORDERS_HISTORY_SAVE_FILTER";
export const ORDERS_HISTORY_SAVE_FILTER_TYPE = "ORDERS_HISTORY_SAVE_FILTER_TYPE";
export const ORDERS_HISTORY_SAVE_ORDERS = "ORDERS_HISTORY_SAVE_ORDERS";
export const ORDERS_HISTORY_SAVE_ORDER_DETAIL = "ORDERS_HISTORY_SAVE_ORDER_DETAIL";
export const ORDERS_HISTORY_SAVE_PLAIN_ORDER_DETAIL = "ORDERS_HISTORY_SAVE_PLAIN_ORDER_DETAIL";
export const ORDERS_HISTORY_SAVE_SORTING = "ORDERS_HISTORY_SAVE_SORTING";
export const ORDERS_HISTORY_LIST_UPDATE = "ORDERS_HISTORY_LIST_UPDATE";
export const ORDERS_HISTORY_SAVE_ORDER_LIST_WITH_OFFSET = "ORDERS_HISTORY_SAVE_ORDER_LIST_WITH_OFFSET";

// favorites tab
export const FAVORITES_TAB_INIT = "FAVORITES_TAB_INIT";
export const SELECT_FROM_FAVORITES = "SELECT_FROM_FAVORITES";
export const SELECT_TAB_FAVORITE_FOLDER = "SELECT_TAB_FAVORITE_FOLDER";
export const FAV_TAB_REMOVE_FROM_FAVORITES = "FAV_TAB_REMOVE_FROM_FAVORITES";
export const ADD_FAVORITES_FOLDER = "ADD_FAVORITES_FOLDER";
export const EDIT_FAVORITES_FOLDER = "EDIT_FAVORITES_FOLDER";
export const DELETE_FAVORITES_FOLDER = "DELETE_FAVORITES_FOLDER";
export const EDIT_FAVORITES = "EDIT_FAVORITES";

// matching tab
export const CORRECTION_SAVE_MEASUREMENT_RESULT = "CORRECTION_SAVE_MEASUREMENT_RESULT";
export const CORRECTION_SAVE_RESULT = "CORRECTION_SAVE_RESULT";
export const CORRECTION_SAVE_SPECTRAL_DATA = "CORRECTION_SAVE_SPECTRAL_DATA";
export const CORRECTION_SAVE_TARGET_COLOR_MEASUREMENT_RESULT = "CORRECTION_SAVE_TARGET_COLOR_MEASUREMENT_RESULT";
export const CORRECTION_SAVE_TARGET_COLOR_SPECTRAL_DATA = "CORRECTION_SAVE_TARGET_COLOR_SPECTRAL_DATA";
export const CORRECTION_SAVE_TARGET_FORMULA = "CORRECTION_SAVE_TARGET_FORMULA";
export const MATCHING_AVAILABLE = "MATCHING_AVAILABLE";
export const MATCHING_INIT_ENGINE = "MATCHING_INIT_ENGINE";
export const MATCHING_INITIALIZED = "MATCHING_INITIALIZED";
export const MATCHING_SAVE_BASE_LIST = "MATCHING_SAVE_BASE_LIST";
export const MATCHING_SAVE_COLORANT_LIST = "MATCHING_SAVE_COLORANT_LIST";
export const MATCHING_SAVE_MEASURE_RESULT_AND_OPEN_PREVIEW = "MATCHING_SAVE_MEASURE_RESULT_AND_OPEN_PREVIEW";
export const MATCHING_SAVE_PACKAGE_LIST = "MATCHING_SAVE_PACKAGE_LIST";
export const MATCHING_SAVE_PRODUCT_LIST = "MATCHING_SAVE_PRODUCT_LIST";
export const MATCHING_SAVE_RESULT = "MATCHING_SAVE_RESULT";
export const MATCHING_SAVE_TEMPLATE_LIST = "MATCHING_SAVE_TEMPLATE_LIST";
export const MATCHING_SELECT_CUSTOM_FANDECK = "MATCHING_SELECT_CUSTOM_FANDECK";
export const MATCHING_TAB_CHANGE_COLOR_NAME = "MATCHING_TAB_CHANGE_COLOR_NAME";
export const MATCHING_TAB_INIT = "MATCHING_TAB_INIT";
export const MATCHING_TAB_INIT_SEARCH = "MATCHING_TAB_INIT_SEARCH";
export const MATCHING_TAB_REMOVE_BASE = "MATCHING_TAB_REMOVE_BASE";
export const MATCHING_TAB_SAVE_COLOR_LIST = "MATCHING_TAB_SAVE_COLOR_LIST";
export const MATCHING_TAB_SAVE_COLOR_LIST_WITH_OFFSET = "MATCHING_TAB_SAVE_COLOR_LIST_WITH_OFFSET";
export const MATCHING_TAB_SAVE_COLORFILE_LIST = "MATCHING_TAB_SAVE_COLORFILE_LIST";
export const MATCHING_TAB_SAVE_FANDECK_LIST = "MATCHING_TAB_SAVE_FANDECK_LIST";
export const MATCHING_TAB_SAVE_FANDECK_LIST_WITH_OFFSET = "MATCHING_TAB_SAVE_FANDECK_LIST_WITH_OFFSET";
export const MATCHING_TAB_SELECT_BASE = "MATCHING_TAB_SELECT_BASE";
export const MATCHING_TAB_SELECT_COLOR = "MATCHING_TAB_SELECT_COLOR";
export const MATCHING_TAB_SELECT_COLORFILE = "MATCHING_TAB_SELECT_COLORFILE";
export const MATCHING_TAB_SELECT_CORRECTION_COLORFILE = "MATCHING_TAB_SELECT_CORRECTION_COLORFILE";
export const MATCHING_TAB_SELECT_FANDECK = "MATCHING_TAB_SELECT_FANDECK";
export const MATCHING_TAB_SELECT_MATCHING_RESULT = "MATCHING_TAB_SELECT_MATCHING_RESULT";
export const MATCHING_TAB_SELECT_PACKAGE = "MATCHING_TAB_SELECT_PACKAGE";
export const MATCHING_TAB_SELECT_PRODUCT = "MATCHING_TAB_SELECT_PRODUCT";
export const MATCHING_TAB_SELECT_TEMPLATE = "MATCHING_TAB_SELECT_TEMPLATE";
export const MATCHING_TAB_SET_COLORANT = "MATCHING_TAB_SET_COLORANT";
export const MATCHING_TAB_SET_CORRECTION_SCENE = "MATCHING_TAB_SET_CORRECTION_SCENE";
export const MATCHING_TAB_SET_DRAFT_FORMULA_SCENE = "MATCHING_TAB_SET_DRAFT_FORMULA_SCENE";
export const MATCHING_TAB_INIT_DRAFT_FORMULA_SCENE = "MATCHING_TAB_INIT_DRAFT_FORMULA_SCENE";
export const REFORMULATION_SAVE_RESULT = "REFORMULATION_SAVE_RESULT";
export const SAVE_CORRECTION_HISTORY = "SAVE_CORRECTION_HISTORY";

// quality control
export const QUALITY_CONTROL_INIT = "QUALITY_CONTROL_INIT";
export const QC_SAVE_MEASURE_RESULT_AND_RUN_COLOR_DIFFERENCE = "QC_SAVE_MEASURE_RESULT_AND_RUN_COLOR_DIFFERENCE";
export const QC_SAVE_SPECTRAL_DIFFERENCE = "QC_SAVE_SPECTRAL_DIFFERENCE";

// main tab
export const FORMULA_STORE_INIT = "FORMULA_STORE_INIT";
export const SAVE_FORMULA_DATA = "SAVE_FORMULA_DATA";
export const RELOAD_FORMULA_META_DATA = "RELOAD_FORMULA_META_DATA";
export const RELOAD_FORMULA_META_DATA_WITH_UFI = "RELOAD_FORMULA_META_DATA_WITH_UFI";
export const RELOAD_DISPENSING_FORMULA_META_DATA = "RELOAD_DISPENSING_FORMULA_META_DATA";
export const SAVE_FORMULA_META_AND_PRINT_DATA = "SAVE_FORMULA_META_AND_PRINT_DATA";
export const SET_NUMBER_OF_PACKAGES = "SET_NUMBER_OF_PACKAGES";
export const SET_NUMBER_OF_LABELS = "SET_NUMBER_OF_LABELS";
export const MAIN_TAB_CREATE_ORDER = "MAIN_TAB_CREATE_ORDER";
export const MAIN_TAB_SET_PACKAGE = "MAIN_TAB_SET_PACKAGE";
export const MAIN_TAB_SET_MARGIN = "MAIN_TAB_SET_MARGIN";
export const MAIN_TAB_RELOAD_AFTER_PARTIAL_UPDATE = "MAIN_TAB_RELOAD_AFTER_PARTIAL_UPDATE";
export const MAIN_TAB_RELOAD_FORMULA_DATA = "MAIN_TAB_RELOAD_FORMULA_DATA";
export const MAIN_TAB_RELOAD_FORMULA_PRICE_DATA = "MAIN_TAB_RELOAD_FORMULA_PRICE_DATA";
export const MAIN_TAB_RELOAD_REQUIRED = "MAIN_TAB_RELOAD_REQUIRED";
export const MAIN_TAB_SET_CUSTOMER = "MAIN_TAB_SET_CUSTOMER";
export const MAIN_TAB_SAVE_FORMULA_COLORANTS = "MAIN_TAB_SAVE_FORMULA_COLORANTS";
export const MAIN_TAB_SAVE_STANDARD_FORMULA_COLORANTS = "MAIN_TAB_SAVE_STANDARD_FORMULA_COLORANTS";
export const MAIN_TAB_SAVE_MODIFIED_FORMULA_COLORANTS = "MAIN_TAB_SAVE_MODIFIED_FORMULA_COLORANTS";
export const MAIN_TAB_START_FORMULA_DISPENSING = "MAIN_TAB_START_FORMULA_DISPENSING";
export const MAIN_TAB_START_QUICK_DISPENSING = "MAIN_TAB_START_QUICK_DISPENSING";
export const MAIN_TAB_DELETE_CUSTOMER = "MAIN_TAB_DELETE_CUSTOMER";
export const UPDATE_DISPENSING_INFO = "UPDATE_DISPENSING_INFO";
export const UPDATE_FORMULA_DISPENSING_INFO = "UPDATE_FORMULA_DISPENSING_INFO";
export const MAIN_TAB_SAVE_PACKAGE_IMAGE = "MAIN_TAB_SAVE_PACKAGE_IMAGE";
export const MAIN_TAB_SAVE_DISPENSE_NOTE = "MAIN_TAB_SAVE_DISPENSE_NOTE";
export const MAIN_TAB_SAVE_INTERNAL_NOTE = "MAIN_TAB_SAVE_INTERNAL_NOTE";
export const MAIN_TAB_DELETE_DISPENSE_NOTE = "MAIN_TAB_DELETE_DISPENSE_NOTE";
export const MAIN_TAB_DELETE_INTERNAL_NOTE = "MAIN_TAB_DELETE_INTERNAL_NOTE";
export const SAVE_FANDECK_COLOR_COUNT = "SAVE_FANDECK_COLOR_COUNT";
export const FORMULA_TAB_EDIT_FORMULA_RGB = "FORMULA_TAB_EDIT_FORMULA_RGB";
export const UPDATE_PRODUCT_FILE_PAGES = "UPDATE_PRODUCT_FILE_PAGES";
export const UPDATE_PRODUCT_FILE_PAGES_ONLINE = "UPDATE_PRODUCT_FILE_PAGES_ONLINE";
export const SAVE_COLOR_IN_FANDECK_RGB = "SAVE_COLOR_IN_FANDECK_RGB";
export const SAVE_FORMULA_CIF_RGB = "SAVE_FORMULA_CIF_RGB";
export const MAIN_TAB_SAVE_BUILDING_SITES = "MAIN_TAB_SAVE_BUILDING_SITES";
export const MAIN_TAB_SAVE_BUILDING_SITES_WITH_OFFSET = "MAIN_TAB_SAVE_BUILDING_SITES_WITH_OFFSET";
export const MAIN_TAB_SET_BUILDING_SITE = "MAIN_TAB_SET_BUILDING_SITE";
export const MAIN_TAB_DELETE_BUILDING_SITE = "MAIN_TAB_DELETE_BUILDING_SITE";
export const SAVE_FORMULA_VALIDATION = "SAVE_FORMULA_VALIDATION";
export const MAIN_TAB_RESET_PRICE_LIST = "MAIN_TAB_RESET_PRICE_LIST";

// product
export const SAVE_PRODUCT_LIST_SEARCH = "SAVE_PRODUCT_LIST_SEARCH";
export const SAVE_PRODUCT_LIST_SEARCH_WITH_AUTOSELECT = "SAVE_PRODUCT_LIST_SEARCH_WITH_AUTOSELECT";
export const SELECT_PRODUCT = "SELECT_PRODUCT";
export const AUTOSELECT_PRODUCT = "AUTOSELECT_PRODUCT";

// fandeck
export const RELOAD_FANDECK_LIST_SEARCH = "RELOAD_FANDECK_LIST_SEARCH";
export const SAVE_FANDECK_LIST_SEARCH = "SAVE_FANDECK_LIST_SEARCH";
export const SAVE_FANDECK_LIST_SEARCH_WITH_AUTOSELECT = "SAVE_FANDECK_LIST_SEARCH_WITH_AUTOSELECT";
export const SAVE_FANDECK_LIST_SEARCH_WITH_OFFSET = "SAVE_FANDECK_LIST_SEARCH_WITH_OFFSET";
export const SELECT_FANDECK = "SELECT_FANDECK";
export const AUTOSELECT_FANDECK = "AUTOSELECT_FANDECK";

// formula
export const RELOAD_FORMULA_LIST_SEARCH_BY_NAME = "RELOAD_FORMULA_LIST_SEARCH_BY_NAME";
export const RELOAD_FORMULA_LIST_SEARCH_BY_CODE = "RELOAD_FORMULA_LIST_SEARCH_BY_CODE";
export const RELOAD_FORMULA_LIST_SEARCH_BY_NAME_AND_CODE = "RELOAD_FORMULA_LIST_SEARCH_BY_NAME_AND_CODE";
export const SAVE_FORMULA_MORE_INFO = "SAVE_FORMULA_MORE_INFO";
export const SAVE_FORMULA_SPECTRAL_DATA = "SAVE_FORMULA_SPECTRAL_DATA";
export const SAVE_FORMULA_LIST_SEARCH_INIT = "SAVE_FORMULA_LIST_SEARCH_INIT";
export const SAVE_FORMULA_LIST_SEARCH = "SAVE_FORMULA_LIST_SEARCH";
export const SAVE_FORMULA_LIST_SEARCH_WITH_AUTOSELECT = "SAVE_FORMULA_LIST_SEARCH_WITH_AUTOSELECT";
export const SAVE_FORMULA_LIST_SEARCH_WITH_OFFSET = "SAVE_FORMULA_LIST_SEARCH_WITH_OFFSET";
export const SAVE_FORMULA_CODE_LIST_SEARCH_INIT = "SAVE_FORMULA_CODE_LIST_SEARCH_INIT";
export const SAVE_FORMULA_CODE_LIST_SEARCH = "SAVE_FORMULA_CODE_LIST_SEARCH";
export const SAVE_FORMULA_CODE_LIST_SEARCH_WITH_OFFSET = "SAVE_FORMULA_CODE_LIST_SEARCH_WITH_OFFSET";
export const SELECT_FORMULA = "SELECT_FORMULA";
export const SELECT_FORMULA_NAME_AND_CODE = "SELECT_FORMULA_NAME_AND_CODE";
export const SELECT_COLOR_PALETTE_FORMULA = "SELECT_COLOR_PALETTE_FORMULA";
export const SAVE_HISTORICAL_FORMULAS = "SAVE_HISTORICAL_FORMULAS";
export const SAVE_ALTERNATIVE_FORMULAS = "SAVE_ALTERNATIVE_FORMULAS";
export const UPDATE_FORMULA_FROM_HISTORICAL_FORMULA = "UPDATE_FORMULA_FROM_HISTORICAL_FORMULA";
export const GET_PRINT_PREVIEW_IMAGE = "GET_PRINT_PREVIEW_IMAGE";
export const EXPORT_PRINT_PREVIEW_TO_PDF = "EXPORT_PRINT_PREVIEW_TO_PDF";
export const START_PRINT_REPORT_SILENT = "START_PRINT_REPORT_SILENT";
export const AUTOSELECT_FORMULA = "AUTOSELECT_FORMULA";
export const REMOVE_FORMULA_DATA = "REMOVE_FORMULA_DATA";
export const SAVE_BROWSE_COLOR_LIST = "SAVE_BROWSE_COLOR_LIST";
export const SAVE_BROWSE_COLOR_LIST_WITH_OFFSET = "SAVE_BROWSE_COLOR_LIST_WITH_OFFSET";
export const RELOAD_SEARCH_PANEL_COLOR_PALETTE = "RELOAD_SEARCH_PANEL_COLOR_PALETTE";
export const SELECT_CLOSEST_COLOR_AND_FANDECK = "SELECT_CLOSEST_COLOR_AND_FANDECK";
export const COLORANT_PANEL_INIT = "COLORANT_PANEL_INIT";
export const SET_COLORANT_PANEL_ACTIVE_UNIT = "SET_COLORANT_PANEL_ACTIVE_UNIT";
export const SET_COLORANT_PANEL_COLORANT_LIST = "SET_COLORANT_PANEL_COLORANT_LIST";
export const GET_CLOSEST_COLOR = "GET_CLOSEST_COLOR";
export const GET_CLOSEST_COLOR_WITH_PRICES = "GET_CLOSEST_COLOR_WITH_PRICES";
export const SET_CLOSEST_COLORS_FOR_MISSING_FORMULA = "SET_CLOSEST_COLORS_FOR_MISSING_FORMULA";

// base
export const RELOAD_BASE_LIST_SEARCH = "RELOAD_BASE_LIST_SEARCH";
export const SAVE_BASE_LIST_SEARCH = "SAVE_BASE_LIST_SEARCH";
export const SAVE_BASE_LIST_SEARCH_WITH_AUTOSELECT = "SAVE_BASE_LIST_SEARCH_WITH_AUTOSELECT";
export const SAVE_BASE_LIST_SEARCH_WITH_OFFSET = "SAVE_BASE_LIST_SEARCH_WITH_OFFSET";
export const SELECT_BASE = "SELECT_BASE";
export const AUTOSELECT_BASE = "AUTOSELECT_BASE";

// bipp
export const RELOAD_BIPP_LIST_SEARCH = "RELOAD_BIPP_LIST_SEARCH";
export const SAVE_BIPP_LIST_SEARCH = "SAVE_BIPP_LIST_SEARCH";
export const SAVE_BIPP_LIST_SEARCH_WITH_AUTOSELECT = "SAVE_BIPP_LIST_SEARCH_WITH_AUTOSELECT";
export const SAVE_BIPP_LIST_SEARCH_WITH_OFFSET = "SAVE_BIPP_LIST_SEARCH_WITH_OFFSET";
export const SELECT_BIPP = "SELECT_BIPP";
export const AUTOSELECT_BIPP = "AUTOSELECT_BIPP";

// search panel
export const SEARCH_PANEL_INIT = "SEARCH_PANEL_INIT";
export const FILTER_PRODUCT_LIST = "FILTER_PRODUCT_LIST";
export const FILTER_PRODUCT_LIST_BY_NAME = "FILTER_PRODUCT_LIST_BY_NAME";
export const FILTER_FANDECK_LIST = "FILTER_FANDECK_LIST";
export const FILTER_FANDECK_LIST_BY_NAME = "FILTER_FANDECK_LIST_BY_NAME";
export const FILTER_FORMULA_LIST = "FILTER_FORMULA_LIST";
export const FILTER_FORMULA_LIST_BY_NAME = "FILTER_FORMULA_LIST_BY_NAME";
export const FILTER_FORMULA_LIST_BY_CODE = "FILTER_FORMULA_LIST_BY_CODE";
export const FILTER_FORMULA_LIST_BY_NAME_AND_CODE = "FILTER_FORMULA_LIST_BY_NAME_AND_CODE";
export const FILTER_BASE_LIST = "FILTER_BASE_LIST";
export const FILTER_BASE_LIST_BY_NAME = "FILTER_BASE_LIST_BY_NAME";
export const FILTER_BIPP_LIST = "FILTER_BIPP_LIST";
export const FILTER_BIPP_LIST_BY_NAME = "FILTER_BIPP_LIST_BY_NAME";
export const SET_SEARCH_PANEL = "SET_SEARCH_PANEL";
export const UPDATE_SEARCH_PANEL = "UPDATE_SEARCH_PANEL";
export const CONSTRUCT_SEARCH_PANEL = "CONSTRUCT_SEARCH_PANEL";
export const SEARCH_PANEL_GET_FORMULA = "SEARCH_PANEL_GET_FORMULA";
export const SEARCH_PANEL_SET_ACTIVE_SELECT = "SEARCH_PANEL_SET_ACTIVE_SELECT";
export const SEARCH_PANEL_SET_PRODUCT_NAME_INPUT = "SEARCH_PANEL_SET_PRODUCT_NAME_INPUT";
export const SEARCH_PANEL_SET_FANDECK_NAME_INPUT = "SEARCH_PANEL_SET_FANDECK_NAME_INPUT";
export const SEARCH_PANEL_SET_FORMULA_INPUT = "SEARCH_PANEL_SET_FORMULA_INPUT";
export const SEARCH_PANEL_SET_FORMULA_NAME_INPUT = "SEARCH_PANEL_SET_FORMULA_NAME_INPUT";
export const SEARCH_PANEL_SET_FORMULA_CODE_INPUT = "SEARCH_PANEL_SET_FORMULA_CODE_INPUT";
export const SEARCH_PANEL_SET_BASE_NAME_INPUT = "SEARCH_PANEL_SET_BASE_NAME_INPUT";
export const SEARCH_PANEL_SET_BIPP_NAME_INPUT = "SEARCH_PANEL_SET_BIPP_NAME_INPUT";
export const SEARCH_PANEL_REMOVE_SELECTED = "SEARCH_PANEL_REMOVE_SELECTED";
export const SEARCH_PANEL_CHECK_AUTOSELECT = "SEARCH_PANEL_CHECK_AUTOSELECT";
export const SEARCH_PANEL_FOCUS_ON_NEXT_PANEL = "SEARCH_PANEL_FOCUS_ON_NEXT_PANEL";
export const SEARCH_PANEL_TOGGLE_FORMULA_NAME_SORT = "SEARCH_PANEL_TOGGLE_FORMULA_NAME_SORT";
export const SEARCH_PANEL_TOGGLE_FORMULA_CODE_SORT = "SEARCH_PANEL_TOGGLE_FORMULA_CODE_SORT";
export const SET_GLOBAL_CUSTOM_SEARCH = "SET_GLOBAL_CUSTOM_SEARCH";

// initial tab
export const SAVE_LAST_DISPENSED_FORMULAS_WITH_OFFSET = "SAVE_LAST_DISPENSED_FORMULAS_WITH_OFFSET";

// customers
export const SAVE_CUSTOMER_LIST = "SAVE_CUSTOMER_LIST";
export const SAVE_LAST_CUSTOMER_LIST = "SAVE_LAST_CUSTOMER_LIST";
export const SAVE_CUSTOMER_LIST_WITH_OFFSET = "SAVE_CUSTOMER_LIST_WITH_OFFSET";
export const SAVE_CUSTOMER_DETAIL = "SAVE_CUSTOMER_DETAIL";
export const CUSTOMERS_TAB_INIT = "CUSTOMERS_TAB_INIT";
export const CUSTOMERS_CHANGE_FILTER = "CUSTOMERS_CHANGE_FILTER";
export const CUSTOMERS_CHANGE_OFFSET = "CUSTOMERS_CHANGE_OFFSET";
export const CUSTOMERS_TAB_RESET = "CUSTOMERS_TAB_RESET";

// custom tab
export const CUSTOM_TAB_ADD_CUSTOM_FORMULA = "CUSTOM_TAB_ADD_CUSTOM_FORMULA";
export const CUSTOM_TAB_AUTOSELECT_FANDECK = "CUSTOM_TAB_AUTOSELECT_FANDECK";
export const CUSTOM_TAB_CHANGE_FORMULA_CODE = "CUSTOM_TAB_CHANGE_FORMULA_CODE";
export const CUSTOM_TAB_CHANGE_FORMULA_NAME = "CUSTOM_TAB_CHANGE_FORMULA_NAME";
export const CUSTOM_TAB_INIT = "CUSTOM_TAB_INIT";
export const CUSTOM_TAB_REMOVE_SELECTED_BASE = "CUSTOM_TAB_REMOVE_SELECTED_BASE";
export const CUSTOM_TAB_REMOVE_SELECTED_FANDECK = "CUSTOM_TAB_REMOVE_SELECTED_FANDECK";
export const CUSTOM_TAB_REMOVE_SELECTED_PRODUCT = "CUSTOM_TAB_REMOVE_SELECTED_PRODUCT";
export const CUSTOM_TAB_SAVE_BASE_LIST = "CUSTOM_TAB_SAVE_BASE_LIST";
export const CUSTOM_TAB_SAVE_MASTER_PRODUCT_LIST = "CUSTOM_TAB_SAVE_MASTER_PRODUCT_LIST";
export const CUSTOM_TAB_SAVE_MASTER_PRODUCT_NAME = "CUSTOM_TAB_SAVE_MASTER_PRODUCT_NAME";
export const CUSTOM_TAB_SELECT_BASE = "CUSTOM_TAB_SELECT_BASE";
export const CUSTOM_TAB_SELECT_FANDECK = "CUSTOM_TAB_SELECT_FANDECK";
export const CUSTOM_TAB_SELECT_PRODUCT = "CUSTOM_TAB_SELECT_PRODUCT";
export const CUSTOM_TAB_SET_MASTER_PRODUCT = "CUSTOM_TAB_SET_MASTER_PRODUCT";
export const CUSTOM_TAB_SET_MORE_INFO_TEXT = "CUSTOM_TAB_SET_MORE_INFO_TEXT";
export const CUSTOM_TAB_SET_PACKAGE = "CUSTOM_TAB_SET_PACKAGE";

// formula
export const FORMULA_COLORANTS_EDIT = "FORMULA_COLORANTS_EDIT";
export const PRINT_FORMULA_WHILE_DISPENSING = "PRINT_FORMULA_WHILE_DISPENSING";
export const SAVE_DISPENSING_PACKAGE_IMAGE = "SAVE_DISPENSING_PACKAGE_IMAGE";

//settings
export const SAVE_SETTING_OPTIONS = "SAVE_SETTING_OPTIONS";
export const INIT_USER_SETTINGS = "INIT_USER_SETTINGS";
export const SAVE_USER_SETTINGS = "SAVE_USER_SETTINGS";

// setting items
export const SETTINGS_SAVE_ACTIVE_FORMULA_UNIT = "SETTINGS_SAVE_ACTIVE_FORMULA_UNIT";
export const SETTINGS_SAVE_ADDITIONAL_TAB_TYPE = "SETTINGS_SAVE_ADDITIONAL_TAB_TYPE";
export const SETTINGS_SAVE_ALTERNATIVE_FORMULAS_POSITION = "SETTINGS_SAVE_ALTERNATIVE_FORMULAS_POSITION";
export const SETTINGS_SAVE_AUTO_CLOSE_TAB = "SETTINGS_SAVE_AUTO_CLOSE_TAB";
export const SETTINGS_SAVE_AUTOMATIC_CLIENT_START = "SETTINGS_SAVE_AUTOMATIC_CLIENT_START";
export const SETTINGS_SAVE_AUTOMATIC_LOGOUT = "SETTINGS_SAVE_AUTOMATIC_LOGOUT";
export const SETTINGS_SAVE_AUTOMATIC_LOGOUT_TIMEOUT = "SETTINGS_SAVE_AUTOMATIC_LOGOUT_TIMEOUT";
export const SETTINGS_SAVE_AUTOMATIC_PRINT = "SETTINGS_SAVE_AUTOMATIC_PRINT";
export const SETTINGS_SAVE_BARCODES_ENABLED = "SETTINGS_SAVE_BARCODES_ENABLED";
export const SETTINGS_SAVE_BLEND_FORMULA_AND_CODE = "SETTINGS_SAVE_BLEND_FORMULA_AND_CODE";
export const SETTINGS_SAVE_BUILDING_SITE = "SETTINGS_SAVE_BUILDING_SITE";
export const SETTINGS_SAVE_CLEANING_TIME = "SETTINGS_SAVE_CLEANING_TIME";
export const SETTINGS_SAVE_COLOR_PREVIEW_AS_IMAGE = "SETTINGS_SAVE_COLOR_PREVIEW_AS_IMAGE";
export const SETTINGS_SAVE_COLOR_PREVIEW_RESIZABLE = "SETTINGS_SAVE_COLOR_PREVIEW_RESIZABLE";
export const SETTINGS_SAVE_COLOR_TAB_COMPATIBLE_ONLY = "SETTINGS_SAVE_COLOR_TAB_COMPATIBLE_ONLY";
export const SETTINGS_SAVE_COLOR_TAB_FORMULA_CODE = "SETTINGS_SAVE_COLOR_TAB_FORMULA_CODE";
export const SETTINGS_SAVE_COLOR_TAB_FORMULA_NAME = "SETTINGS_SAVE_COLOR_TAB_FORMULA_NAME";
export const SETTINGS_SAVE_COLOR_TAB_NOTE_ICONS = "SETTINGS_SAVE_COLOR_TAB_NOTE_ICONS";
export const SETTINGS_SAVE_COLOR_TAB_ORDER_BY = "SETTINGS_SAVE_COLOR_TAB_ORDER_BY";
export const SETTINGS_SAVE_COLOR_TAB_ROW_COUNT = "SETTINGS_SAVE_COLOR_TAB_ROW_COUNT";
export const SETTINGS_SAVE_COLOR_TAB_WARNING_ICON = "SETTINGS_SAVE_COLOR_TAB_WARNING_ICON";
export const SETTINGS_SAVE_COLORANT_BATCH_FOR_MULTIPLE_CANS = "SETTINGS_SAVE_COLORANT_BATCH_FOR_MULTIPLE_CANS";
export const SETTINGS_SAVE_COLORANT_BATCH_NUMBER_LOGIC = "SETTINGS_SAVE_COLORANT_BATCH_NUMBER_LOGIC";
export const SETTINGS_SAVE_COLORANT_PANEL_LIMIT = "SETTINGS_SAVE_COLORANT_PANEL_LIMIT";
export const SETTINGS_SAVE_COLORANT_PANEL_ORDER_BY = "SETTINGS_SAVE_COLORANT_PANEL_ORDER_BY";
export const SETTINGS_SAVE_COMPETITIVE_COLOR_SEARCH = "SETTINGS_SAVE_COMPETITIVE_COLOR_SEARCH";
export const SETTINGS_SAVE_CUSTOM_BANNER_POSITION = "SETTINGS_SAVE_CUSTOM_BANNER_POSITION";
export const SETTINGS_SAVE_CUSTOM_CAN_OPTION = "SETTINGS_SAVE_CUSTOM_CAN_OPTION";
export const SETTINGS_SAVE_CUSTOM_CAN_SETTINGS_UNIT_GRAV = "SETTINGS_SAVE_CUSTOM_CAN_SETTINGS_UNIT_GRAV";
export const SETTINGS_SAVE_CUSTOM_CAN_SETTINGS_UNIT_VOL = "SETTINGS_SAVE_CUSTOM_CAN_SETTINGS_UNIT_VOL";
export const SETTINGS_SAVE_CUSTOM_CAN_SIZE = "SETTINGS_SAVE_CUSTOM_CAN_SIZE";
export const SETTINGS_SAVE_CUSTOM_CAN_UNITS = "SETTINGS_SAVE_CUSTOM_CAN_UNITS";
export const SETTINGS_SAVE_CUSTOM_FORMAT_CURRENCY = "SETTINGS_SAVE_CUSTOM_FORMAT_CURRENCY";
export const SETTINGS_SAVE_CUSTOM_FORMAT_DATE = "SETTINGS_SAVE_CUSTOM_FORMAT_DATE";
export const SETTINGS_SAVE_CUSTOM_FORMAT_NUMBER = "SETTINGS_SAVE_CUSTOM_FORMAT_NUMBER";
export const SETTINGS_SAVE_CUSTOM_FORMAT_TIME = "SETTINGS_SAVE_CUSTOM_FORMAT_TIME";
export const SETTINGS_SAVE_CUSTOM_FORMULA_FOR_MASTER_PRODUCT = "SETTINGS_SAVE_CUSTOM_FORMULA_FOR_MASTER_PRODUCT";
export const SETTINGS_SAVE_CUSTOM_FORMULA_FOR_MASTER_PRODUCT_DEFAULT =
    "SETTINGS_SAVE_CUSTOM_FORMULA_FOR_MASTER_PRODUCT_DEFAULT";
export const SETTINGS_SAVE_CUSTOM_FORMULAS = "SETTINGS_SAVE_CUSTOM_FORMULAS";
export const SETTINGS_SAVE_CUSTOM_HOME_BUTTON = "SETTINGS_SAVE_CUSTOM_HOME_BUTTON";
export const SETTINGS_SAVE_CUSTOMERS_ENABLED = "SETTINGS_SAVE_CUSTOMERS_ENABLED";
export const SETTINGS_SAVE_DEFAULT_PRINTER = "SETTINGS_SAVE_DEFAULT_PRINTER";
export const SETTINGS_SAVE_DEFAULT_TEMPLATE = "SETTINGS_SAVE_DEFAULT_TEMPLATE";
export const SETTINGS_SAVE_DEFAULT_TEMPLATE_QUICKTINT = "SETTINGS_SAVE_DEFAULT_TEMPLATE_QUICKTINT";
export const SETTINGS_SAVE_DELETE_CONFIRMATION = "SETTINGS_SAVE_DELETE_CONFIRMATION";
export const SETTINGS_SAVE_DISK_SPACE_NOTIFICATION = "SETTINGS_SAVE_DISK_SPACE_NOTIFICATION";
export const SETTINGS_SAVE_DISPENSING_ENABLED = "SETTINGS_SAVE_DISPENSING_ENABLED";
export const SETTINGS_SAVE_DISPENSING_NOTES = "SETTINGS_SAVE_DISPENSING_NOTES";
export const SETTINGS_SAVE_DISPENSING_WITH_ERRORS_ENABLED = "SETTINGS_SAVE_DISPENSING_WITH_ERRORS_ENABLED";
export const SETTINGS_SAVE_EDIT_COLORANT_ALLOWANCE = "SETTINGS_SAVE_EDIT_COLORANT_ALLOWANCE";
export const SETTINGS_SAVE_FANDECK_GROUPS = "SETTINGS_SAVE_FANDECK_GROUPS";
export const SETTINGS_SAVE_FILE_TRANSFER = "SETTINGS_SAVE_FILE_TRANSFER";
export const SETTINGS_SAVE_FILE_TRANSFER_IN_TASKS = "SETTINGS_SAVE_FILE_TRANSFER_IN_TASKS";
export const SETTINGS_SAVE_FILE_TRANSFER_OUT_TASKS = "SETTINGS_SAVE_FILE_TRANSFER_OUT_TASKS";
export const SETTINGS_SAVE_FORMULA_AUTOMATIC_NAMING = "SETTINGS_SAVE_FORMULA_AUTOMATIC_NAMING";
export const SETTINGS_SAVE_FORMULA_CODE = "SETTINGS_SAVE_FORMULA_CODE";
export const SETTINGS_SAVE_FORMULA_CODE_PRIMARY = "SETTINGS_SAVE_FORMULA_CODE_PRIMARY";
export const SETTINGS_SAVE_FORMULA_COLOR_PREVIEW = "SETTINGS_SAVE_FORMULA_COLOR_PREVIEW";
export const SETTINGS_SAVE_FORMULA_MODIFICATION_PANEL = "SETTINGS_SAVE_FORMULA_MODIFICATION_PANEL";
export const SETTINGS_SAVE_FORMULA_NAME = "SETTINGS_SAVE_FORMULA_NAME";
export const SETTINGS_SAVE_FORMULA_NOTES = "SETTINGS_SAVE_FORMULA_NOTES";
export const SETTINGS_SAVE_FORMULA_PREVIEW = "SETTINGS_SAVE_FORMULA_PREVIEW";
export const SETTINGS_SAVE_FORMULA_PROPERTIES_POSITION = "SETTINGS_SAVE_FORMULA_PROPERTIES_POSITION";
export const SETTINGS_SAVE_FORMULA_STATUS_PANEL = "SETTINGS_SAVE_FORMULA_STATUS_PANEL";
export const SETTINGS_SAVE_FORMULA_UNITS = "SETTINGS_SAVE_FORMULA_UNITS";
export const SETTINGS_SAVE_FTS = "SETTINGS_SAVE_FTS";
export const SETTINGS_SAVE_GENERATE_COLOR_PREVIEW = "SETTINGS_SAVE_GENERATE_COLOR_PREVIEW";
export const SETTINGS_SAVE_HELP = "SETTINGS_SAVE_HELP";
export const SETTINGS_SAVE_HELP_LINK = "SETTINGS_SAVE_HELP_LINK";
export const SETTINGS_SAVE_HELPER_AUTO_CHECK = "SETTINGS_SAVE_HELPER_AUTO_CHECK";
export const SETTINGS_SAVE_HELPER_AUTO_CHECK_INTERVAL = "SETTINGS_SAVE_HELPER_AUTO_CHECK_INTERVAL";
export const SETTINGS_SAVE_HELPER_AUTO_DOWNLOAD = "SETTINGS_SAVE_HELPER_AUTO_DOWNLOAD";
export const SETTINGS_SAVE_HELPER_AUTO_FORCE_INSTALL = "SETTINGS_SAVE_HELPER_AUTO_FORCE_INSTALL";
export const SETTINGS_SAVE_HELPER_AUTO_INSTALL = "SETTINGS_SAVE_HELPER_AUTO_INSTALL";
export const SETTINGS_SAVE_HELPER_AUTO_INSTALL_DELAY = "SETTINGS_SAVE_HELPER_AUTO_INSTALL_DELAY";
export const SETTINGS_SAVE_HELPER_AUTO_INSTALL_NEW_DBS = "SETTINGS_SAVE_HELPER_AUTO_INSTALL_NEW_DBS";
export const SETTINGS_SAVE_HELPER_AUTO_NIGHT_CHECK = "SETTINGS_SAVE_HELPER_AUTO_NIGHT_CHECK";
export const SETTINGS_SAVE_HELPER_AUTO_REBOOT_DELAY = "SETTINGS_SAVE_HELPER_AUTO_REBOOT_DELAY";
export const SETTINGS_SAVE_HISTORICAL_FORMULAS_POSITION = "SETTINGS_SAVE_HISTORICAL_FORMULAS_POSITION";
export const SETTINGS_SAVE_IMAGES_SOURCE = "SETTINGS_SAVE_IMAGES_SOURCE";
export const SETTINGS_SAVE_INFO_DATA = "SETTINGS_SAVE_INFO_DATA";
export const SETTINGS_SAVE_INFO_ITEM_IN_RGB_PREVIEW = "SETTINGS_SAVE_INFO_ITEM_IN_RGB_PREVIEW";
export const SETTINGS_SAVE_INFO_PANEL_RESIZABLE = "SETTINGS_SAVE_INFO_PANEL_RESIZABLE";
export const SETTINGS_SAVE_INFO_PANEL_TAB = "SETTINGS_SAVE_INFO_PANEL_TAB";
export const SETTINGS_SAVE_INITIAL_TAB_TYPE = "SETTINGS_SAVE_INITIAL_TAB_TYPE";
export const SETTINGS_SAVE_KEYBOARD_SHORTCUTS = "SETTINGS_SAVE_KEYBOARD_SHORTCUTS";
export const SETTINGS_SAVE_KIOSK = "SETTINGS_SAVE_KIOSK";
export const SETTINGS_SAVE_LIGHT_AT_STARTUP = "SETTINGS_SAVE_LIGHT_AT_STARTUP";
export const SETTINGS_SAVE_LOCALE = "SETTINGS_SAVE_LOCALE";
export const SETTINGS_SAVE_LOCK_COMPUTER = "SETTINGS_SAVE_LOCK_COMPUTER";
export const SETTINGS_SAVE_MANUAL_ADDITION_UNIT = "SETTINGS_SAVE_MANUAL_ADDITION_UNIT";
export const SETTINGS_SAVE_MASTER_PRODUCT_SIBLINGS_TABLE = "SETTINGS_SAVE_MASTER_PRODUCT_SIBLINGS_TABLE";
export const SETTINGS_SAVE_MATCHING_INFO_CR = "SETTINGS_SAVE_MATCHING_INFO_CR";
export const SETTINGS_SAVE_MATCHING_INFO_DELTA_E1 = "SETTINGS_SAVE_MATCHING_INFO_DELTA_E1";
export const SETTINGS_SAVE_MATCHING_INFO_DELTA_E2 = "SETTINGS_SAVE_MATCHING_INFO_DELTA_E2";
export const SETTINGS_SAVE_MATCHING_INFO_DELTA_E3 = "SETTINGS_SAVE_MATCHING_INFO_DELTA_E3";
export const SETTINGS_SAVE_MATCHING_INFO_DIN = "SETTINGS_SAVE_MATCHING_INFO_DIN";
export const SETTINGS_SAVE_MATCHING_INFO_LRV = "SETTINGS_SAVE_MATCHING_INFO_LRV";
export const SETTINGS_SAVE_MATCHING_INFO_RMS = "SETTINGS_SAVE_MATCHING_INFO_RMS";
export const SETTINGS_SAVE_MATCHING_OPTIONS_COLORANTS = "SETTINGS_SAVE_MATCHING_OPTIONS_COLORANTS";
export const SETTINGS_SAVE_MATCHING_OPTIONS_COLORFILE = "SETTINGS_SAVE_MATCHING_OPTIONS_COLORFILE";
export const SETTINGS_SAVE_MATCHING_OPTIONS_SORT_RESULTS = "SETTINGS_SAVE_MATCHING_OPTIONS_SORT_RESULTS";
export const SETTINGS_SAVE_MATCHING_ROW_COUNT = "SETTINGS_SAVE_MATCHING_ROW_COUNT";
export const SETTINGS_SAVE_MATCHING_TABLE_BASE = "SETTINGS_SAVE_MATCHING_TABLE_BASE";
export const SETTINGS_SAVE_MATCHING_TABLE_COLORANTS = "SETTINGS_SAVE_MATCHING_TABLE_COLORANTS";
export const SETTINGS_SAVE_MATCHING_TABLE_CR = "SETTINGS_SAVE_MATCHING_TABLE_CR";
export const SETTINGS_SAVE_MATCHING_TABLE_DELTA_E1 = "SETTINGS_SAVE_MATCHING_TABLE_DELTA_E1";
export const SETTINGS_SAVE_MATCHING_TABLE_DELTA_E2 = "SETTINGS_SAVE_MATCHING_TABLE_DELTA_E2";
export const SETTINGS_SAVE_MATCHING_TABLE_DELTA_E3 = "SETTINGS_SAVE_MATCHING_TABLE_DELTA_E3";
export const SETTINGS_SAVE_MATCHING_TABLE_DIN = "SETTINGS_SAVE_MATCHING_TABLE_DIN";
export const SETTINGS_SAVE_MATCHING_TABLE_LRV = "SETTINGS_SAVE_MATCHING_TABLE_LRV";
export const SETTINGS_SAVE_MATCHING_TABLE_PRICE = "SETTINGS_SAVE_MATCHING_TABLE_PRICE";
export const SETTINGS_SAVE_MATCHING_TABLE_RMS = "SETTINGS_SAVE_MATCHING_TABLE_RMS";
export const SETTINGS_SAVE_MAX_TOLERANCE_OF_COMPETITIVE_COLORS = "SETTINGS_SAVE_MAX_TOLERANCE_OF_COMPETITIVE_COLORS";
export const SETTINGS_SAVE_MORE_INFO_INTERNAL = "SETTINGS_SAVE_MORE_INFO_INTERNAL";
export const SETTINGS_SAVE_NAVIGATION_ITEMS = "SETTINGS_SAVE_NAVIGATION_ITEMS";
export const SETTINGS_SAVE_NUMBER_OF_COMPETITIVE_COLORS = "SETTINGS_SAVE_NUMBER_OF_COMPETITIVE_COLORS";
export const SETTINGS_SAVE_NUMBER_OF_TABS = "SETTINGS_SAVE_NUMBER_OF_TABS";
export const SETTINGS_SAVE_ORDER_MODAL_ENABLED = "SETTINGS_SAVE_ORDER_MODAL_ENABLED";
export const SETTINGS_SAVE_ORDER_SEARCH_ITEMS = "SETTINGS_SAVE_ORDER_SEARCH_ITEMS";
export const SETTINGS_SAVE_ORDERING_ENABLED = "SETTINGS_SAVE_ORDERING_ENABLED";
export const SETTINGS_SAVE_OVERWRITE_LAST_TAB = "SETTINGS_SAVE_OVERWRITE_LAST_TAB";
export const SETTINGS_SAVE_PRICE_TYPES = "SETTINGS_SAVE_PRICE_TYPES";
export const SETTINGS_SAVE_PRICE_VISIBILITY_TYPE = "SETTINGS_SAVE_PRICE_VISIBILITY_TYPE";
export const SETTINGS_SAVE_PRICING_ENABLED = "SETTINGS_SAVE_PRICING_ENABLED";
export const SETTINGS_SAVE_PRINT_AFTER_DISPENSING = "SETTINGS_SAVE_PRINT_AFTER_DISPENSING";
export const SETTINGS_SAVE_PRINT_AS_IMAGE = "SETTINGS_SAVE_PRINT_AS_IMAGE";
export const SETTINGS_SAVE_PRINT_BEFORE_DISPENSING = "SETTINGS_SAVE_PRINT_BEFORE_DISPENSING";
export const SETTINGS_SAVE_PRINT_ENABLED = "SETTINGS_SAVE_PRINT_ENABLED";
export const SETTINGS_SAVE_PRINT_ON_REQUEST = "SETTINGS_SAVE_PRINT_ON_REQUEST";
export const SETTINGS_SAVE_PRINT_TASKS_AFTER_DISPENSING = "SETTINGS_SAVE_PRINT_TASKS_AFTER_DISPENSING";
export const SETTINGS_SAVE_PRINT_TASKS_BEFORE_DISPENSING = "SETTINGS_SAVE_PRINT_TASKS_BEFORE_DISPENSING";
export const SETTINGS_SAVE_PRODUCT_CODE = "SETTINGS_SAVE_PRODUCT_CODE";
export const SETTINGS_SAVE_PRODUCT_FILES_SOURCE = "SETTINGS_SAVE_PRODUCT_FILES_SOURCE";
export const SETTINGS_SAVE_PRODUCT_GROUPS = "SETTINGS_SAVE_PRODUCT_GROUPS";
export const SETTINGS_SAVE_PRODUCT_IMAGE_PREVIEW_ENABLED = "SETTINGS_SAVE_PRODUCT_IMAGE_PREVIEW_ENABLED";
export const SETTINGS_SAVE_QUALITY_CONTROL_COLOR_DIFFERENCE = "SETTINGS_SAVE_QUALITY_CONTROL_COLOR_DIFFERENCE";
export const SETTINGS_SAVE_QUALITY_CONTROL_DELTA_A = "SETTINGS_SAVE_QUALITY_CONTROL_DELTA_A";
export const SETTINGS_SAVE_QUALITY_CONTROL_DELTA_B = "SETTINGS_SAVE_QUALITY_CONTROL_DELTA_B";
export const SETTINGS_SAVE_QUALITY_CONTROL_DELTA_E = "SETTINGS_SAVE_QUALITY_CONTROL_DELTA_E";
export const SETTINGS_SAVE_QUALITY_CONTROL_DELTA_L = "SETTINGS_SAVE_QUALITY_CONTROL_DELTA_L";
export const SETTINGS_SAVE_QUALITY_CONTROL_METAMERISM = "SETTINGS_SAVE_QUALITY_CONTROL_METAMERISM";
export const SETTINGS_SAVE_QUALITY_CONTROL_ENABLED = "SETTINGS_SAVE_QUALITY_CONTROL_ENABLED";
export const SETTINGS_SAVE_QUICK_TINT_SORTING_TYPE = "SETTINGS_SAVE_QUICK_TINT_SORTING_TYPE";
export const SETTINGS_SAVE_QUICK_TINT_WINDOW_CLOSING_RULE = "SETTINGS_SAVE_QUICK_TINT_WINDOW_CLOSING_RULE";
export const SETTINGS_SAVE_RCC_BARCODE_REFILL = "SETTINGS_SAVE_RCC_BARCODE_REFILL";
export const SETTINGS_SAVE_RCC_BASE_CAN_BARCODE_VALIDATION = "SETTINGS_SAVE_RCC_BASE_CAN_BARCODE_VALIDATION";
export const SETTINGS_SAVE_RCC_CHECK_CAN_BEFORE_DISPENSE = "SETTINGS_SAVE_RCC_CHECK_CAN_BEFORE_DISPENSE";
export const SETTINGS_SAVE_RCC_CHECK_OVERFILL = "SETTINGS_SAVE_RCC_CHECK_OVERFILL";
export const SETTINGS_SAVE_RCC_DISPENSE_INVALID_COLORANTS = "SETTINGS_SAVE_RCC_DISPENSE_INVALID_COLORANTS";
export const SETTINGS_SAVE_RCC_MANUAL_COLORANT_ADDITION = "SETTINGS_SAVE_RCC_MANUAL_COLORANT_ADDITION";
export const SETTINGS_SAVE_RCC_MINIMAL_DISPENSE_AMOUNT = "SETTINGS_SAVE_RCC_MINIMAL_DISPENSE_AMOUNT";
export const SETTINGS_SAVE_RCC_PLACE_CAN_SENSOR = "SETTINGS_SAVE_RCC_PLACE_CAN_SENSOR";
export const SETTINGS_SAVE_RCC_PLACE_CAN_SENSOR_DELAY = "SETTINGS_SAVE_RCC_PLACE_CAN_SENSOR_DELAY";
export const SETTINGS_SAVE_RCC_REMOVE_CAN_SENSOR = "SETTINGS_SAVE_RCC_REMOVE_CAN_SENSOR";
export const SETTINGS_SAVE_RCC_REMOVE_CAN_SENSOR_DELAY = "SETTINGS_SAVE_RCC_REMOVE_CAN_SENSOR_DELAY";
export const SETTINGS_SAVE_RCC_SKIP_PLACE_CAN_DIALOG = "SETTINGS_SAVE_RCC_SKIP_PLACE_CAN_DIALOG";
export const SETTINGS_SAVE_RCC_SKIP_REMOVE_CAN_DIALOG = "SETTINGS_SAVE_RCC_SKIP_REMOVE_CAN_DIALOG";
export const SETTINGS_SAVE_RCC_SPLIT_FORMULA = "SETTINGS_SAVE_RCC_SPLIT_FORMULA";
export const SETTINGS_SAVE_RCC_TMC_ENABLED = "SETTINGS_SAVE_RCC_TMC_ENABLED";
export const SETTINGS_SAVE_RCC_UNIT = "SETTINGS_SAVE_RCC_UNIT";
export const SETTINGS_SAVE_RCC_VALIDATE_COLORANTS_DURING_INIT = "SETTINGS_SAVE_RCC_VALIDATE_COLORANTS_DURING_INIT";
export const SETTINGS_SAVE_RECIRCULATION_SPEED = "SETTINGS_SAVE_RECIRCULATION_SPEED";
export const SETTINGS_SAVE_RECIRCULATION_TIME = "SETTINGS_SAVE_RECIRCULATION_TIME";
export const SETTINGS_SAVE_REDLIKE_LIGHT_ENABLED = "SETTINGS_SAVE_REDLIKE_LIGHT_ENABLED";
export const SETTINGS_SAVE_ROUNDING = "SETTINGS_SAVE_ROUNDING";
export const SETTINGS_SAVE_SEARCH_CHEAPER_COLORS = "SETTINGS_SAVE_SEARCH_CHEAPER_COLORS";
export const SETTINGS_SAVE_SEARCH_PANEL_BASE = "SETTINGS_SAVE_SEARCH_PANEL_BASE";
export const SETTINGS_SAVE_SEARCH_PANEL_BASE_SIZE = "SETTINGS_SAVE_SEARCH_PANEL_BASE_SIZE";
export const SETTINGS_SAVE_SEARCH_PANEL_BIPP = "SETTINGS_SAVE_SEARCH_PANEL_BIPP";
export const SETTINGS_SAVE_SEARCH_PANEL_BIPP_SIZE = "SETTINGS_SAVE_SEARCH_PANEL_BIPP_SIZE";
export const SETTINGS_SAVE_SEARCH_PANEL_DROP_DOWN_CALCULATE = "SETTINGS_SAVE_SEARCH_PANEL_DROP_DOWN_CALCULATE";
export const SETTINGS_SAVE_SEARCH_PANEL_FANDECK_SIZE = "SETTINGS_SAVE_SEARCH_PANEL_FANDECK_SIZE";
export const SETTINGS_SAVE_SEARCH_PANEL_FORMULA_SIZE = "SETTINGS_SAVE_SEARCH_PANEL_FORMULA_SIZE";
export const SETTINGS_SAVE_SEARCH_PANEL_ORDER = "SETTINGS_SAVE_SEARCH_PANEL_ORDER";
export const SETTINGS_SAVE_SEARCH_PANEL_ORDER_BY_DISTANCE = "SETTINGS_SAVE_SEARCH_PANEL_ORDER_BY_DISTANCE";
export const SETTINGS_SAVE_SEARCH_PANEL_PRODUCT = "SETTINGS_SAVE_SEARCH_PANEL_PRODUCT";
export const SETTINGS_SAVE_SEARCH_PANEL_PRODUCT_SIZE = "SETTINGS_SAVE_SEARCH_PANEL_PRODUCT_SIZE";
export const SETTINGS_SAVE_SEARCH_PANEL_QUICK_SELECT = "SETTINGS_SAVE_SEARCH_PANEL_QUICK_SELECT";
export const SETTINGS_SAVE_SOUND_ENABLED = "SETTINGS_SAVE_SOUND_ENABLED";
export const SETTINGS_SAVE_SPECTRO_ENABLED = "SETTINGS_SAVE_SPECTRO_ENABLED";
export const SETTINGS_SAVE_STIRRING_SPEED = "SETTINGS_SAVE_STIRRING_SPEED";
export const SETTINGS_SAVE_STIRRING_TIME = "SETTINGS_SAVE_STIRRING_TIME";
export const SETTINGS_SAVE_STOCK_DATABASE_FILTER = "SETTINGS_STOCK_SAVE_DATABASE_FILTER";
export const SETTINGS_SAVE_STOCK_TABLE_ORDER_BY = "SETTINGS_STOCK_SAVE_TABLE_ORDER_BY";
export const SETTINGS_SAVE_TABLE_ANSWER = "SETTINGS_SAVE_TABLE_ANSWER";
export const SETTINGS_SAVE_TABLE_BASE = "SETTINGS_SAVE_TABLE_BASE";
export const SETTINGS_SAVE_TABLE_BIPP = "SETTINGS_SAVE_TABLE_BIPP";
export const SETTINGS_SAVE_TABLE_BUILDING_SITE = "SETTINGS_SAVE_TABLE_BUILDING_SITE";
export const SETTINGS_SAVE_TABLE_CLIENT_NAME = "SETTINGS_SAVE_TABLE_CLIENT_NAME";
export const SETTINGS_SAVE_TABLE_COLOR_NAME = "SETTINGS_SAVE_TABLE_COLOR_NAME";
export const SETTINGS_SAVE_TABLE_COMMENT = "SETTINGS_SAVE_TABLE_COMMENT";
export const SETTINGS_SAVE_TABLE_CREATED = "SETTINGS_SAVE_TABLE_CREATED";
export const SETTINGS_SAVE_TABLE_CUSTOMER = "SETTINGS_SAVE_TABLE_CUSTOMER";
export const SETTINGS_SAVE_TABLE_DATE = "SETTINGS_SAVE_TABLE_DATE";
export const SETTINGS_SAVE_TABLE_FANDECK = "SETTINGS_SAVE_TABLE_FANDECK";
export const SETTINGS_SAVE_TABLE_FORMULA_CODE = "SETTINGS_SAVE_TABLE_FORMULA_CODE";
export const SETTINGS_SAVE_TABLE_FORMULA_NAME = "SETTINGS_SAVE_TABLE_FORMULA_NAME";
export const SETTINGS_SAVE_TABLE_MORE_INFO = "SETTINGS_SAVE_TABLE_MORE_INFO";
export const SETTINGS_SAVE_TABLE_MORE_INFO_INTERNAL = "SETTINGS_SAVE_TABLE_MORE_INFO_INTERNAL";
export const SETTINGS_SAVE_TABLE_OPERATOR = "SETTINGS_SAVE_TABLE_OPERATOR";
export const SETTINGS_SAVE_TABLE_PACKAGE = "SETTINGS_SAVE_TABLE_PACKAGE";
export const SETTINGS_SAVE_TABLE_PRODUCT = "SETTINGS_SAVE_TABLE_PRODUCT";
export const SETTINGS_SAVE_TABLE_STATUS = "SETTINGS_SAVE_TABLE_STATUS";
export const SETTINGS_SAVE_TABLE_SUBJECT = "SETTINGS_SAVE_TABLE_SUBJECT";
export const SETTINGS_SAVE_TABLE_TICKET_ID = "SETTINGS_SAVE_TABLE_TICKET_ID";
export const SETTINGS_SAVE_TABLE_TYPE = "SETTINGS_SAVE_TABLE_TYPE";

export const SETTINGS_SAVE_TABLE_QUALITY_CONTROL = "SETTINGS_SAVE_TABLE_QUALITY_CONTROL";
export const SETTINGS_SAVE_TABLE_QUANTITY = "SETTINGS_SAVE_TABLE_QUANTITY";
export const SETTINGS_SAVE_TABS_ENABLED = "SETTINGS_SAVE_TABS_ENABLED";
export const SETTINGS_SAVE_TABS_MEMORY = "SETTINGS_SAVE_TABS_MEMORY";
export const SETTINGS_SAVE_TINTOMETRIC_SYSTEM = "SETTINGS_SAVE_TINTOMETRIC_SYSTEM";
export const SETTINGS_SAVE_UFI_CODE_BASE_VALIDATION = "SETTINGS_SAVE_UFI_CODE_BASE_VALIDATION";
export const SETTINGS_SAVE_UFI_CODE_LOGIC = "SETTINGS_SAVE_UFI_CODE_LOGIC";
export const SETTINGS_SAVE_UFI_CODE_MIN_AMOUNT_GRAV_PERCENT = "SETTINGS_SAVE_UFI_CODE_MIN_AMOUNT_GRAV_PERCENT";
export const SETTINGS_SAVE_UFI_CODE_MIN_GRAV_PERCENT = "SETTINGS_SAVE_UFI_CODE_MIN_GRAV_PERCENT";
export const SETTINGS_SAVE_USER_IDENTIFICATION = "SETTINGS_SAVE_USER_IDENTIFICATION";
export const SETTINGS_SAVE_VALIDATE_COLORANT_BASE_RULES = "SETTINGS_SAVE_VALIDATE_COLORANT_BASE_RULES";
export const SETTINGS_SAVE_VALIDATE_MIN_DOSABLE_AMOUNT = "SETTINGS_SAVE_VALIDATE_MIN_DOSABLE_AMOUNT";
export const SETTINGS_SAVE_VALIDATE_OVERFILL = "SETTINGS_SAVE_VALIDATE_OVERFILL";
export const SETTINGS_SAVE_VALIDATE_TOTAL_CNT_AMOUNTS = "SETTINGS_SAVE_VALIDATE_TOTAL_CNT_AMOUNTS";
export const SETTINGS_SAVE_VIRTUAL_KEYBOARD_ENABLED = "SETTINGS_SAVE_VIRTUAL_KEYBOARD_ENABLED";
export const SETTINGS_SAVE_VISIBLE_UNITS = "SETTINGS_SAVE_VISIBLE_UNITS";
export const SETTINGS_SAVE_ZOOM = "SETTINGS_SAVE_ZOOM";

//custom data
export const CUSTOM_DATA_SAVE_SUPPORTED_IMPORT_FORMATS = "CUSTOM_DATA_SAVE_SUPPORTED_IMPORT_FORMATS";
export const CUSTOM_DATA_UPDATE_IMPORT_FORMAT = "CUSTOM_DATA_UPDATE_IMPORT_FORMAT";
export const CUSTOM_DATA_DELETE_IMPORTED_DATA = "CUSTOM_DATA_DELETE_IMPORTED_DATA";
export const CUSTOM_DATA_IMPORTING_START = "CUSTOM_DATA_IMPORTING_START";
export const CUSTOM_DATA_SAVE_PROGRESS = "CUSTOM_DATA_SAVE_PROGRESS";
export const CUSTOM_DATA_ABORT_IMPORTING = "CUSTOM_DATA_ABORT_IMPORTING";
export const CUSTOM_DATA_IMPORTING_END = "CUSTOM_DATA_IMPORTING_END";
export const CUSTOM_DATA_IMPORTING_ABORTED = "CUSTOM_DATA_IMPORTING_ABORTED";

//pricing
export const RELOAD_PRICE_SETTINGS_DATA = "RELOAD_PRICE_SETTINGS_DATA";
export const SAVE_PRICING_GENERIC_DATA = "SAVE_PRICING_GENERIC_DATA";
export const SAVE_PRICING_GENERIC_COLORANT_DATA = "SAVE_PRICING_GENERIC_COLORANT_DATA";
export const SAVE_PRICING_GENERIC_PACKAGE_DATA = "SAVE_PRICING_GENERIC_PACKAGE_DATA";
export const SAVE_PRICING_GENERIC_PRODUCT_DATA = "SAVE_PRICING_GENERIC_PRODUCT_DATA";
export const SAVE_PRICING_COLORANT_DATA = "SAVE_PRICING_COLORANT_DATA";
export const SAVE_PRICING_PACKAGE_DATA = "SAVE_PRICING_PACKAGE_DATA";
export const SAVE_PRICING_BASE_IN_PRODUCTS_DATA = "SAVE_PRICING_BASE_IN_PRODUCTS_DATA";
export const SAVE_PRICING_PRODUCT_DATA = "SAVE_PRICING_PRODUCT_DATA";
export const SAVE_PRICING_ACTIVE_PRODUCT = "SAVE_PRICING_ACTIVE_PRODUCT";

export const PRICE_DATA_IMPORTING_START = "PRICE_DATA_IMPORTING_START";
export const PRICE_DATA_ABORT_IMPORTING = "PRICE_DATA_ABORT_IMPORTING";
export const PRICE_DATA_IMPORTING_END = "PRICE_DATA_IMPORTING_END";

export const INIT_PRICE_SETTINGS = "INIT_PRICE_SETTINGS";
export const SAVE_PRICE_SETTINGS = "SAVE_PRICE_SETTINGS";
export const PRICE_SETTINGS_SAVE_LOCAL_PRICES = "PRICE_SETTINGS_SAVE_LOCAL_PRICES";
export const PRICE_SETTINGS_SAVE_PRICE_DEFINITION = "PRICE_SETTINGS_SAVE_PRICE_DEFINITION";
export const PRICE_SETTINGS_SAVE_PRICE_UNIT_DEFINITION = "PRICE_SETTINGS_SAVE_PRICE_UNIT_DEFINITION";
export const PRICE_SETTINGS_SAVE_PRICE_GROUP_NUMBER = "PRICE_SETTINGS_SAVE_PRICE_GROUP_NUMBER";
export const PRICE_SETTINGS_SAVE_PRICE_GROUPS = "PRICE_SETTINGS_SAVE_PRICE_GROUPS";
export const PRICE_SETTINGS_SAVE_MARGIN = "PRICE_SETTINGS_SAVE_MARGIN";
export const PRICE_SETTINGS_SAVE_MARKUP = "PRICE_SETTINGS_SAVE_MARKUP";
export const PRICE_SETTINGS_SAVE_DISCOUNT = "PRICE_SETTINGS_SAVE_DISCOUNT";

// margin settings
export const SAVE_MARGIN_LIST = "SAVE_MARGIN_LIST";

// currencies
export const SAVE_CURRENCY_LIST = "SAVE_CURRENCY_LIST";
export const SAVE_ACTIVE_CURRENCY = "SAVE_ACTIVE_CURRENCY";
export const SAVE_PRIMARY_CURRENCY = "SAVE_PRIMARY_CURRENCY";

// rcc state
export const OPEN_RCC_DIALOG = "OPEN_RCC_DIALOG";
export const CANCEL_RCC_DIALOG = "CANCEL_RCC_DIALOG";
export const TOGGLE_RCC_DIALOG = "TOGGLE_RCC_DIALOG";
export const SAVE_RCC_DIALOG = "SAVE_RCC_DIALOG";
export const OPEN_SPECTRO_DIALOG = "OPEN_SPECTRO_DIALOG";
export const CANCEL_SPECTRO_DIALOG = "CANCEL_SPECTRO_DIALOG";
export const TOGGLE_SPECTRO_DIALOG = "TOGGLE_SPECTRO_DIALOG";
export const HIDE_ALL_DIALOGS = "HIDE_ALL_DIALOGS";
export const SAVE_SPECTRO_DIALOG = "SAVE_SPECTRO_DIALOG";
export const SAVE_RCC_DIALOG_PROGRESS = "SAVE_RCC_DIALOG_PROGRESS";
export const MACHINE_CONNECT = "MACHINE_CONNECT";
export const MACHINE_SET_SELECTION = "MACHINE_SET_SELECTION";
export const MACHINE_SET_CONNECTION = "MACHINE_SET_CONNECTION";
export const SAVE_MACHINE_CALLS = "SAVE_MACHINE_CALLS";
export const SAVE_AUTOTASK_TYPES = "SAVE_AUTOTASK_TYPES";
export const SAVE_MACHINE_INFO = "SAVE_MACHINE_INFO";
export const SAVE_MACHINE_DRIVER_CONFIGURATION = "SAVE_MACHINE_DRIVER_CONFIGURATION";
export const SAVE_MACHINE_DRIVER_TYPES = "SAVE_MACHINE_DRIVER_TYPES";
export const SAVE_MACHINE_CONFIGURATION = "SAVE_MACHINE_CONFIGURATION";
export const SAVE_MACHINE_CONFIGURATION_AND_RELOAD_CANISTERS = "SAVE_MACHINE_CONFIGURATION_AND_RELOAD_CANISTERS";
export const INIT_SPECTRO_CONFIGURATION = "INIT_SPECTRO_CONFIGURATION";
export const SAVE_SPECTRO_CONFIGURATION = "SAVE_SPECTRO_CONFIGURATION";
export const SAVE_SPECTRO_TYPES = "SAVE_SPECTRO_TYPES";
export const SAVE_SPECTRO_COM_PORTS = "SAVE_SPECTRO_COM_PORTS";
export const SAVE_SPECTRO_XRITE_MODELS = "SAVE_SPECTRO_XRITE_MODELS";
export const SAVE_MACHINE_DEVICES = "SAVE_MACHINE_DEVICES";
export const SAVE_MACHINE_CANISTERS = "SAVE_MACHINE_CANISTERS";
export const SAVE_MACHINE_CHANNELS = "SAVE_MACHINE_CHANNELS";
export const SAVE_MACHINE_ERRORS = "SAVE_MACHINE_ERRORS";
export const MACHINE_SET_BUSY = "MACHINE_SET_BUSY";
export const MACHINE_DISPENSE_FORMULA = "MACHINE_DISPENSE_FORMULA";
export const MACHINE_DISPENSE_HISTORY_FORMULA = "MACHINE_DISPENSE_HISTORY_FORMULA";
export const INIT_QUICK_DISPENSING = "INIT_QUICK_DISPENSING";
export const START_QUICK_DISPENSING = "START_QUICK_DISPENSING";
export const SET_BLOCKED_UI = "SET_BLOCKED_UI";
export const MACHINE_VALIDATE_DISPENSED_FORMULA = "MACHINE_VALIDATE_DISPENSED_FORMULA";
export const MACHINE_SAVE_VALIDATION_RESULT = "MACHINE_SAVE_VALIDATION_RESULT";
export const MACHINE_SAVE_VALIDATION_CANISTER = "MACHINE_SAVE_VALIDATION_CANISTER";
export const MACHINE_SAVE_VALIDATION_COLORANT_PACKAGE = "MACHINE_SAVE_VALIDATION_COLORANT_PACKAGE";
export const MACHINE_CONFIRM_REFILL_VALIDATION = "MACHINE_CONFIRM_REFILL_VALIDATION";
export const MACHINE_RESET_REFILL_VALIDATION = "MACHINE_RESET_REFILL_VALIDATION";
export const MACHINE_REFILL_CANISTER = "MACHINE_REFILL_CANISTER";
export const MACHINE_UPDATE_REFILL_VALIDATION_WIZARD = "MACHINE_UPDATE_REFILL_VALIDATION_WIZARD";
export const SAVE_DISPENSING_FORMULA = "SAVE_DISPENSING_FORMULA";
export const POP_DISPENSING_FORMULA = "POP_DISPENSING_FORMULA";
export const SAVE_MACHINE_HISTORY_ACTIONS = "SAVE_MACHINE_HISTORY_ACTIONS";
export const SPECTRO_SET_SELECT = "SPECTRO_SET_SELECT";
export const SPECTRO_SET_CONNECTION = "SPECTRO_SET_CONNECTION";
export const SAVE_SPECTRO_CALLS = "SAVE_SPECTRO_CALLS";
export const SAVE_SPECTRO_INFO = "SAVE_SPECTRO_INFO";
export const SAVE_SPECTRO_CALIBRATED = "SAVE_SPECTRO_CALIBRATED";
export const SAVE_SPECTRO_MEASURE_RESULT = "SAVE_SPECTRO_MEASURE_RESULT";
export const UPDATE_SPECTRO_PREVIEW = "UPDATE_SPECTRO_PREVIEW";
export const SAVE_SPECTRO_FORMULAS = "SAVE_SPECTRO_FORMULAS";
export const ADD_DISPENSING_FORMULA_TO_STATS = "ADD_DISPENSING_FORMULA_TO_STATS";
export const SAVE_MACHINE_REFILL_HISTORY = "SAVE_MACHINE_REFILL_HISTORY";
export const SAVE_MACHINE_REFILL_HISTORY_WITH_OFFSET = "SAVE_MACHINE_REFILL_HISTORY_WITH_OFFSET";
export const MACHINE_DIALOG_CONTINUE = "MACHINE_DIALOG_CONTINUE";
export const UPDATE_MACHINE_SENSOR = "UPDATE_MACHINE_SENSOR";
export const SAVE_DEFAULT_PRINTER = "SAVE_DEFAULT_PRINTER";
export const SAVE_PRINTERS_LIST = "SAVE_PRINTERS_LIST";
export const SAVE_TEMPLATES_LIST = "SAVE_TEMPLATES_LIST";
export const SAVE_MACHINE_UNITS = "SAVE_MACHINE_UNITS";
export const SAVE_MACHINE_MESSAGE_CODES = "SAVE_MACHINE_MESSAGE_CODES";
export const SAVE_AUTOTASK_LIST = "SAVE_AUTOTASK_LIST";
export const SAVE_SMART_PURGE_RULES_LIST = "SAVE_SMART_PURGE_RULES_LIST";
export const SAVE_MACHINE_ALL_BATCH_NUMBERS = "SAVE_MACHINE_ALL_BATCH_NUMBERS";
export const MACHINE_SAVE_DRIVER_RECONNECT = "MACHINE_SAVE_DRIVER_RECONNECT";
export const SET_MANUAL_COLORANT_ADDITION_UNIT = "SET_MANUAL_COLORANT_ADDITION_UNIT";
export const SAVE_MACHINE_DIALOG_TEXT = "SAVE_MACHINE_DIALOG_TEXT";
export const PURGE_STATS_INIT = "PURGE_STATS_INIT";
export const SAVE_PURGE_STATS = "SAVE_PURGE_STATS";
export const PURGE_STATS_EXIT = "PURGE_STATS_EXIT";
export const SAVE_MANUAL_FORMULA = "SAVE_MANUAL_FORMULA";
export const SAVE_MANUAL_FORMULA_MY_ORDERS = "SAVE_MANUAL_FORMULA_MY_ORDERS";
export const SAVE_MANUAL_FORMULA_TO_DISPENSE = "SAVE_MANUAL_FORMULA_TO_DISPENSE";
export const SAVE_FORMULA_DIRECTLY_TO_STATISTICS = "SAVE_FORMULA_DIRECTLY_TO_STATISTICS";
export const COLORANT_REFILL_HISTORY_INIT = "COLORANT_REFILL_HISTORY_INIT";
export const COLORANT_REFILL_HISTORY_EXIT = "COLORANT_REFILL_HISTORY_EXIT";
export const SAVE_ACTIVE_CANISTER = "SAVE_ACTIVE_CANISTER";
export const SAVE_PACKAGES_FOR_COLORANT = "SAVE_PACKAGES_FOR_COLORANT";
export const SAVE_CANISTER_UFI_CODES = "SAVE_CANISTER_UFI_CODES";
export const SYNC_MACHINE_CONFIGURATION = "SYNC_MACHINE_CONFIGURATION";
export const SYNC_HELPER_CONFIGURATION = "SYNC_HELPER_CONFIGURATION";

// Spectro tab
export const SPECTRO_SAVE_DELTA_FILTER = "SPECTRO_SAVE_DELTA_FILTER";
export const SPECTRO_SAVE_FANDECK_FILTER = "SPECTRO_SAVE_FANDECK_FILTER";
export const SPECTRO_SAVE_PRODUCT_FILTER = "SPECTRO_SAVE_PRODUCT_FILTER";
export const SPECTRO_SAVE_ACTIVE_FORMULA = "SPECTRO_SAVE_ACTIVE_FORMULA";
export const SPECTRO_SET_DELTA_FILTER = "SPECTRO_SET_DELTA_FILTER";
export const SPECTRO_SET_FANDECK_FILTER = "SPECTRO_SET_FANDECK_FILTER";
export const SPECTRO_SET_PRODUCT_FILTER = "SPECTRO_SET_PRODUCT_FILTER";
export const SPECTRO_RELOAD_SEARCH_RESULT = "SPECTRO_RELOAD_SEARCH_RESULT";

// Barcode action
export const GET_BARCODES_BY_PRODUCT_BASE_PACKAGE = "GET_BARCODES_BY_PRODUCT_BASE_PACKAGE";
export const SAVE_BARCODE = "SAVE_BARCODE";
export const SHOW_MANUAL_SCAN = "SHOW_MANUAL_SCAN";
export const SAVE_BARCODE_ITEM = "SAVE_BARCODE_ITEM";
export const BARCODE_RESET = "BARCODE_RESET";
export const SAVE_BARCODE_DATA = "SAVE_BARCODE_DATA";
export const RESET_BARCODE_DATA = "RESET_BARCODE_DATA";

// Stock actions
export const STOCK_CHECK_WARNING_STATUS = "STOCK_CHECK_WARNING_STATUS";
export const STOCK_SAVE_CART = "STOCK_SAVE_CART";
export const STOCK_SAVE_COLORANT_PACKAGES = "STOCK_SAVE_COLORANT_PACKAGES";
export const STOCK_SAVE_WARNING = "STOCK_SAVE_WARNING";
export const STOCK_RESET_CART = "STOCK_RESET_CART";
export const STOCK_RESET_COLORANT_PACKAGES = "STOCK_RESET_COLORANT_PACKAGES";
export const STOCK_CALCULATE_PREDICTION = "STOCK_CALCULATE_PREDICTION";

// Partial updates
export const PARTIAL_UPDATES_SAVE_COUNT = "PARTIAL_UPDATES_SAVE_COUNT";
export const PARTIAL_UPDATES_SAVE_DATA = "PARTIAL_UPDATES_SAVE_DATA";
export const PARTIAL_UPDATES_CLEAN_ALL = "PARTIAL_UPDATES_CLEAN_ALL";

export const INTERGAMMA_SET_OVERRIDE_MODE = "INTERGAMMA_SET_OVERRIDE_MODE";

export const INTERGAMMA_SET_ACTIVE_DATABASE = "INTERGAMMA_SET_ACTIVE_DATABASE";
export const INTERGAMMA_SET_ACTIVE_DATABASE_AFTER_BARCODE = "INTERGAMMA_SET_ACTIVE_DATABASE_AFTER_BARCODE";
export const INTERGAMMA_SET_ACTIVE_DATABASE_AFTER_CIF_BARCODE = "INTERGAMMA_SET_ACTIVE_DATABASE_AFTER_CIF_BARCODE";
export const INTERGAMMA_SELECT_DATABASE = "INTERGAMMA_SELECT_DATABASE";
export const INTERGAMMA_SELECT_PACKAGE = "INTERGAMMA_SELECT_PACKAGE";
export const INTERGAMMA_SAVE_PACKAGE_IMAGE = "INTERGAMMA_SAVE_PACKAGE_IMAGE";
export const INTERGAMMA_SET_LAST_CUSTOMER = "INTERGAMMA_SET_LAST_CUSTOMER";
export const INTERGAMMA_RESET_LAST_CUSTOMER = "INTERGAMMA_RESET_LAST_CUSTOMER";

export const INTERGAMMA_SAVE_COLOR_BY_BARCODE = "INTERGAMMA_SAVE_COLOR_BY_BARCODE";
export const INTERGAMMA_SAVE_COLOR_DATA = "INTERGAMMA_SAVE_COLOR_DATA";

export const INTERGAMMA_RESET_PRODUCT = "INTERGAMMA_RESET_PRODUCT";
export const INTERGAMMA_RESET_COLOR = "INTERGAMMA_RESET_COLOR";
export const INTERGAMMA_RESET_COLOR_WITH_FANDECK = "INTERGAMMA_RESET_COLOR_WITH_FANDECK";
export const INTERGAMMA_RESET_FANDECK = "INTERGAMMA_RESET_FANDECK";
export const INTERGAMMA_RESET_FANDECK_WITH_COLOR = "INTERGAMMA_RESET_FANDECK_WITH_COLOR";
export const INTERGAMMA_RESET_PACKAGE = "INTERGAMMA_RESET_PACKAGE";
export const INTERGAMMA_RESET_NOTE = "INTERGAMMA_RESET_NOTE";

export const INTERGAMMA_SAVE_PRODUCT_LIST = "INTERGAMMA_SAVE_PRODUCT_LIST";
export const INTERGAMMA_SAVE_RELOADED_FORMULA_LIST = "INTERGAMMA_SAVE_RELOADED_FORMULA_LIST";
export const INTERGAMMA_SAVE_RELOADED_FANDECK_LIST = "INTERGAMMA_SAVE_RELOADED_FANDECK_LIST";
export const INTERGAMMA_SAVE_CUSTOMER_LIST = "INTERGAMMA_SAVE_CUSTOMER_LIST";
export const INTERGAMMA_CHANGE_NUMBER_OF_PACKAGES = "INTERGAMMA_CHANGE_NUMBER_OF_PACKAGES";
export const INTERGAMMA_SAVE_CUSTOM_NOTE = "INTERGAMMA_SAVE_CUSTOM_NOTE";

export const SETTINGS_SAVE_KEYBOARD = "SETTINGS_SAVE_KEYBOARD";
export const SETTINGS_SAVE_SCREENSAVER_TIMEOUT = "SETTINGS_SAVE_SCREENSAVER_TIMEOUT";
export const SETTINGS_SAVE_COLOR_FANDECK_WIZARD = "SETTINGS_SAVE_COLOR_FANDECK_WIZARD";
export const SETTINGS_SAVE_MACHINE_SORTING_ORDERS = "SETTINGS_SAVE_MACHINE_SORTING_ORDERS";

export const INTERGAMMA_MACHINE_SET_ACTIVE_DATABASE = "INTERGAMMA_MACHINE_SET_ACTIVE_DATABASE";
export const INTERGAMMA_MACHINE_UPDATE_DATABASE_ACCESS = "INTERGAMMA_MACHINE_UPDATE_DATABASE_ACCESS";

export const INTERGAMMA_CHANGE_DATE_FILTER = "INTERGAMMA_CHANGE_DATE_FILTER";

export const INTERGAMMA_LOAD_HISTORY_ORDER = "INTERGAMMA_LOAD_HISTORY_ORDER";
export const INTERGAMMA_SAVE_ORDER_BARCODE = "INTERGAMMA_SAVE_ORDER_BARCODE";
export const INTERGAMMA_RESET_ORDER_BARCODE = "INTERGAMMA_RESET_ORDER_BARCODE";

export const SAVE_KEYBOARD_STATE = "SAVE_KEYBOARD_STATE";
export const SET_UNIVERSAL_KEYBOARD_STATE = "SET_UNIVERSAL_KEYBOARD_STATE";
export const SAVE_UNIVERSAL_KEYBOARD_STATE = "SAVE_UNIVERSAL_KEYBOARD_STATE";
export const SET_KEYBOARD_TEXT = "SET_KEYBOARD_TEXT";
export const SAVE_POS_FORM_INFO = "INTERGAMMA_SAVE_POS_FORM_INFO";

export const SETUP_BACK = "SETUP_BACK";
export const SETUP_NEXT = "SETUP_NEXT";
export const SETUP_SKIP = "SETUP_SKIP";
export const SETUP_COMPLETED = "SETUP_COMPLETED";
export const SETUP_SET_STEP = "SETUP_SET_STEP";
export const SETUP_UPDATE_PRIVILEGES = "SETUP_UPDATE_PRIVILEGES";
